/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, createContext, useEffect, useReducer, useMemo, useRef, useCallback } from 'react';
import Axios from 'axios';
import dynamic from 'next/dynamic';
import {
  ComponentProps,
  DataUpdateProperties,
  SearchResultAlertType,
  TooltipContentProps,
  TooltipLayerHandle,
} from '../index.types';
import {
  StyledSearchResultContainerDiv,
  StyledFilterContainerDiv,
  StyledSearchResultPropertyContainer,
  StyledAlertNotificationDiv,
} from '../index.styles';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { InitialSearchResult, UpdateSearchResult, UpdateSearchState } from '../store/store.reducer';
import {
  getInitialSearchMockState,
  getSearchResultQuery,
  SearchActions,
  getSearchFilterClearState,
  getSearchAppliedFilter,
  getShopQueryForSearchInput,
} from '../store/store.action';
import SM from '../lib/config';
import { SearchResultAlertContext, SearchFilterContext, SearchResultContext } from '../index.context';
import { PaginationSortByComponent } from '../../../molecules/paginationSortBy';
import CommonUtils from '../lib/CommonUtils';
import {
  clearAllFilterKey,
  DEFAULT_SORT_OPTS,
  DefaultValue,
  maxCapacityKey,
  noAvailabilityKey,
  noHotelsWithinRadiusKey,
  noNearAddressKey,
  propertyCardHiddenAlertCodes,
  RECOMMENDED_OPTION,
  SearchFacetsConstants,
  SearchFacetsList,
  searchFilters,
  SearchPageAlerts,
  SearchSortFieldForDISTANCE,
  SearchSortFieldsDirection,
  tooManyPropertiesErrorKey,
  unsuccessfulSellKey,
  AMPAlertPriority,
  SERPAlertPriority,
  tooltipAmenities,
  SEARCH_FALLBACK_SERVER_ERRORS,
  LinkMatchRegex,
  ErrorFrameworkCodeArray,
  UXL_COMPLETE_FAIL,
  SearchGeographicDestinationTypes,
} from '../index.constant';
import {
  getCurrentPriceRateBlock,
  getCurrRateAmountBlock,
  enableBoostBrands,
  callDataLayerOnFeatureChanges,
  geoCodeAddress,
  getShopTntId,
  executeUXLQueries,
  callDataLayerForSearchFallback,
  isServerError,
  LOWEST_REGULAR_RATE_REQUEST_TYPES,
  updateURLHashCounter,
} from '../lib/helper';
import { SkeletonPropertyCardLoaderComponent } from '../../../molecules/skeletonPropertyCardLoader';
import { getESTDate, Messages } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import {
  getAlertsData,
  getTotalFilterCount,
  updateDataLayerObj,
  updateDataLayerObjSigin,
  extractDataFromDTTResponse,
  getAllPropertyIDS,
  updateSessionDocProperties,
  interactionsAppliedOnSERP,
  fieldsInteractedInSERP,
  isUnsuccessfulUserJourney,
  enableHotelList,
  updateQueryParams,
} from '../lib/helper';
import moment from 'moment';
import { useApolloClient, useMutation } from '@apollo/client';
import { useCheckBreakpoint } from '../../../hooks';
import { phoenixShopUpdateCustomerSavedProperties } from '@marriott/mi-shop-graphql';
import { useConditionalPageContextSERP } from '../../../hooks';
import { getDTTShopResult } from '../lib/shop.dtt.api';
import { inspect } from 'util';
import {
  getBonvoyMemberLevel,
  getDeviceType,
  getLoggerApiURL,
  getMockSearchResultData,
  getRecipeId,
  getSearchDestinationType,
  getSearchDestinationTypeAnalytics,
  getSooModel,
  getWeekType,
  isRecommendedSortSegmentId,
  logger,
  updateSessionDocErrorMessages,
  usePageContextStore,
} from '../../../utils';
import { useConditionalSessionUpdateContext } from '../../../hooks'; // 'libs/mi-shop-components/src/context';
import { getSessionIDFromCookie } from '../../../utils/src/helper';
import { useHQVContext } from '../../../context';
import { HQV_ACTIONS } from '../../../reducers';
import { isLocalDev } from '@marriott/mi-apollo-client-utils';
import { hardCodedAllLocale, validErrorCodes, validWarningCodes } from '../index.constant';
import { useClientEnvVarsStore, usePersistentGlobalStore, useUserDetailsGlobalStore } from '@marriott/mi-store-utils';
import { targetPayloadRequest } from '@marriott/mi-headless-utils';
import {
  convertArabicToEnglishNumbers,
  convertHindiToEnglishNumbers,
} from '../../../lib/organisms/SearchForm/utils/DateUtils';
import {
  propertyCardHiddenCodes,
  REWARDS_REDEMPTION_CLUSTER_CODES_HQV,
  STANDARD_CODE,
  TARGET_SEGMENT_API_ENDPOINT,
  TARGET_SEGMENT_API_ENDPOINT_V1,
} from '../../../constants/lib/constants';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';
import { useSearchFormStore } from '../../../modules/store/searchFormStore';
import { SPECIAL_RATES, DESTINATION_HIDDEN_FIELDS, MAP_VIEW_SESSION_KEY } from '../../../modules/store/store.constants';
import { RATES_DATA } from '../../../modules/constants';
import {
  checkIfGeographicSearchEnabled,
  checkIfSOOEnabled,
  determineExclusionCriteriaForSortOptions,
  isConcurFlowActive,
  isFlexibleDate,
  extractConcurCode,
  getSpecialRatesForSearch,
  hasConcurUserOverride,
  setConcurUserOverride,
} from '../../../modules/utils';
import { useSearchResultsRenderedDataStore } from '../../../modules/store/searchResultsRenderedDataStore';
import { useSearchResultAlertZustandStore } from '../../../modules/store/searchResultAlertZustandStore';
import { useSearchFilterStore } from '../../../modules/store/searchFilterZustandStore';
import { useSavedPropertiesDispatchStore } from '../../../modules/store/savedPropertiesDispatchZustandStore';

import PropertyListComponent from '../../../molecules/propertyList';
import { SearchResultsTooltipLayer } from '../SearchResultsTooltipLayer';
import { FEATURE_FLAGS, FLAG_TYPE } from '@marriott/mi-feature-flag-utils';
import { useGetUserInfo } from '../../../hooks/lib/useGetUserInfo';
const FiltersComponent = dynamic(() =>
  import('../../../molecules/filtersComponent').then(module => module.FiltersComponent)
);
const MemberExclusiveBanner = dynamic(() =>
  import('../../../molecules/memberExclusiveBanner').then(module => module.MemberExclusiveBanner)
);
const AlertNotification = dynamic(() =>
  import('../../../molecules/alerts/AlertNotification').then(module => module.AlertNotification)
);

const { log } = logger({})('SearchResults/searchResultsMainComponent');
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>;
    adobe?: {
      target?: {
        getOffers: any;
      };
    };
  }
}

export const renderedData = createContext({
  jsonContent: {},
  configData: SM,
  isMapViewEnabled: false,
  setISMapViewEnabled: (_value: boolean) => {},

  GOOGLE_MAP_API_KEY: '',

  recentlyViewed: [],
  setRecentlyViewed: () => {},

  featureSelected: false,
  setFeatureSelected: () => {},

  isFlexibleDateSearch: false,
  setIsFlexibleDateSearch: () => {},

  isSearchClicked: false,
  setIsSearchClicked: () => {},

  isStateOrCountry: false,
  setIsStateOrCountry: () => {},

  continueCtaProperty: '',
  setContinueCtaProperty: () => {},

  sessionObject: { consumerID: '', accessToken: '', sessionID: '' },
  setSessionObject: () => {},

  revisionToken: '',
  setRevisionToken: (obj: object) => obj,

  savedProperties: [],
  setSavedProperties: (_savedProperties: string[]) => {},

  formValues: {},
  setFormValues: (_formValues: any) => {},

  isSpecialRateSearch: false,
  setIsSpecialRateSearch: () => {},

  isAutoSuggestSelectedSearch: false,
  setIsAutoSuggestSelectedSearch: (_value: boolean) => {},

  isRecentViewSelectedSearch: false,
  setIsRecentViewSelectedSearch: (_value: boolean) => {},

  isErrorState: true,
  setIsErrorState: () => {},

  isLastCardProcessed: false,
  setIsLastCardProcessed: () => {},

  imageURL: '',
  setImageURL: () => {},

  isTaxesandFeesIncludedFromPopup: false,
  setIsTaxesandFeesIncludedFromPopup: (_value: boolean) => {},

  isStaticMap: false, // Controls whether the map is static (non-interactive) or interactive
  isMapLoading: false, // Controls whether the map loader is shown (used with isStaticMap)
  messageUiData: {},
});

export const SavedPropertiesDispatchContext = createContext<any>({});

const SearchResultComp: React.FC<ComponentProps> = ({
  jsonContent,
  GOOGLE_MAP_API_KEY,
  searchQueryData,
  completeSession,
  AiSearchResults,
  onOpenHotelPanel,
  onPropertyMediaLoaded,
  isStaticMap = false,
  isMapLoading = false,
  messageUiData,
  aiFilterUpdateData,
  aiPreSelectedFacets,
  ampRequest,
}) => {
  const {
    pageState,
    resolvedUrl,
    headersData,
    query,
    currentLocale,
    SESSION_APP_GET_CALL_URL,
    SESSION_GET_CALL_URL_CLIENT,
    datalayerParams,
    datalayerProperties,
    sessionData,
    setSessionData,
    isAuthorMode,
    featureFlagSOO,
    pageVal,
    featureFlagSerpEnableGeographicSearch,
  } = useConditionalPageContextSERP();

  const isSOOEnabled = checkIfSOOEnabled(featureFlagSOO);
  const isGeographicSearchEnabled = checkIfGeographicSearchEnabled(featureFlagSerpEnableGeographicSearch);
  const updatePageContextVar = usePageContextStore(state => state.updatePageContextVar);
  const { envVarsObject } = useClientEnvVarsStore();
  const updateGlobalData = usePersistentGlobalStore((state: any) => state.updateGlobalData);
  const requestId = envVarsObject?.['REQUEST_ID'];

  // Initialize SearchResults renderedData Zustand store
  const searchResultsRenderedDataStore = useSearchResultsRenderedDataStore();

  // Initialize SearchFilter Zustand store
  // Don't call useSearchFilterStore() without selector - it causes new references every render!
  // Use getState() to get stable store reference
  const searchFilterStore = useSearchFilterStore.getState(); // eslint-disable-line react-compiler/react-compiler
  // Always subscribe to searchQueryState changes (required by Rules of Hooks)
  // This ensures component re-renders when filters update in Zustand store
  const zustandSearchQueryState = useSearchFilterStore(state => state.searchQueryState);

  // Initialize SavedPropertiesDispatch Zustand store
  const savedPropertiesDispatchStore = useSavedPropertiesDispatchStore();

  const configData = SM; //load config from config file

  const skipQuery = useMemo(() => {
    return !!pageState?.authorModee || !!isAuthorMode;
  }, [pageState, isAuthorMode]);

  const clientEnvVars = useClientEnvVarsStore(state => state.envVarsObject);
  const google_map_api_key = GOOGLE_MAP_API_KEY ? GOOGLE_MAP_API_KEY : clientEnvVars['GOOGLE_MAP_API_KEY'];
  const NEXT_PUBLIC_PREFIX = process.env['NEXT_PUBLIC_PREFIX'] || clientEnvVars['NEXT_PUBLIC_PREFIX'];
  const loggerApiURL = getLoggerApiURL(NEXT_PUBLIC_PREFIX, headersData?.serpv1 === 'true');
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  const [popPupOpen, setPopupOpen] = useState<boolean>(false);
  const [updateSearchCounter, setUpdateSearchCounter] = useState<number>(0);
  // For chat context, don't hide property list initially (map should show immediately)
  const [hidePropertyList, setHidePropertyList] = useState<boolean>(pageVal === 'chat' ? false : !isStaticMap);

  // When isStaticMap is true, force map view to be enabled and hide property list
  useEffect(() => {
    if (isStaticMap) {
      // Check feature flag to determine if we should sync with Zustand store
      const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
      const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

      // Update local React state (always needed for main component logic)
      setISMapViewEnabled(true);
      // Also update Zustand store if feature flag is enabled
      if (shouldUseZustand) {
        useSearchResultsRenderedDataStore.getState().setISMapViewEnabled(true);
      }
      setHidePropertyList(false);
      setIsLoadingSearchResult(false);
    }
  }, [isStaticMap, envVarsObject]);
  const searchDestinationTypeForDatalayerRef = useRef('');

  /**
   * When the page is loaded with view=map, we want to avoid briefly rendering the
   * list view with results between "results fetched" and "map view enabled".
   * This flag keeps the list hidden until we explicitly turn on map view after
   * the initial search completes.
   */
  const [suppressListUntilMapReady, setSuppressListUntilMapReady] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(searchFilters.view) === 'map';
    } catch {
      return false;
    }
  });
  const [segmentId, setSegmentId] = useState('');
  const [isSavedDataStaleError, setIsSavedDataStaleError] = useState<boolean>(false);
  const [searchDestinationTypeForSession, setSearchDestinationTypeForSession] = useState<string>('');
  // Remove the let variable since we'll use state instead
  const setSearchResultsState = useSearchResultsStore(
    (state: { setSearchResultsState: any }) => state.setSearchResultsState
  );

  const deviceType = getDeviceType();
  const weekType = getWeekType(completeSession?.data?.AriesSearch?.search_is_weekend_stay);
  const searchDestinationType = getSearchDestinationType(
    completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType ?? ''
  );
  const rewardsLevel = getBonvoyMemberLevel(
    completeSession?.data?.AriesCommon?.memState,
    completeSession?.data?.memberLevel,
    completeSession?.data?.AriesCommon?.mr_prof_member_level_abbr
  );
  const searchCity = completeSession?.data?.AriesSearch?.searchCriteria?.address?.city ?? '';
  const searchState = completeSession?.data?.AriesSearch?.searchCriteria?.address?.stateProvince ?? '';
  const searchCountry = completeSession?.data?.AriesSearch?.searchCriteria?.address?.country ?? '';
  const sooModel: string = getSooModel(segmentId);

  const sooOptions = {
    ...(weekType && { weekType: weekType }),
    ...(rewardsLevel && { rewardsLevel: rewardsLevel }),
    ...(searchCity && { searchCity: searchCity }),
    ...(searchState && { searchState: searchState }),
    ...(searchCountry && { searchCountry: searchCountry }),
    deviceType: deviceType,
    searchDestinationType: searchDestinationType,
    sooModel: sooModel,
  };

  const apolloClientRef = useApolloClient(); // create apollo client instance
  const { getMedia, getCurrencyConversionRate, getCustomerToken, getFlexibleFilter, getDatedFilter } =
    getDTTShopResult(apolloClientRef); // import all the api function
  const [isInitialLoad, setInitialLoad] = useState(true);

  const [updatedDestinationType, setUpdatedDestinationType] = useState('');
  const handleNextClick = (isInitialLoadData: boolean): void => {
    setInitialLoad(isInitialLoadData);
  };
  const queryCommonContext = {
    /**
     * define common params for all the query
     */
    context: {
      headers: {
        'x-request-id': requestId,
        'accept-language': currentLocale,
      },
    },
  };

  const destinationType = completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType;

  const stateSearchFromSession =
    isGeographicSearchEnabled &&
    (destinationType === SearchGeographicDestinationTypes.Country ||
      destinationType === SearchGeographicDestinationTypes.State_Province_Region ||
      destinationType === SearchGeographicDestinationTypes.Leisure_Region)
      ? true
      : !completeSession?.data?.AriesSearch?.searchCriteria?.address?.latitude &&
        !completeSession?.data?.AriesSearch?.searchCriteria?.address?.city &&
        (completeSession?.data?.AriesSearch?.searchCriteria?.address?.stateProvince ||
          completeSession?.data?.AriesSearch?.searchCriteria?.address?.country ||
          completeSession?.data?.AriesSearch?.searchCriteria?.address?.region);

  // maintain global state for search result list item
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const mockSearchResult: any = SearchResultMockData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [searchResult, setSearchResult]: any = useReducer(UpdateSearchResult, InitialSearchResult);

  const { hqvDispatch, setPropertySessionData } = useHQVContext();
  /** check if we are getting view=map from session
   * then isMapViewEnabled = true
   */
  const pageResultViewType = completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
    ? completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType === 'map'
    : completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.searchResultViewType === 'map';

  const clickTrackingLoc = 'Phoenix Search Results';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isMapViewEnabled, setMapViewEnabledInternal]: any = useState<boolean>(pageVal === 'chat' ? true : false);
  // Ref to prevent race conditions during view mode changes in chat context
  const isViewModeChangingRef = useRef(false);
  // Wrapper to prevent unwanted state changes during view mode transitions (chat context only)
  const setISMapViewEnabled = useCallback(
    (value: boolean) => {
      // In chat context, if we're changing to list view, set a brief lock to prevent flickering
      if (pageVal === 'chat' && !value) {
        isViewModeChangingRef.current = true;
        setMapViewEnabledInternal(value);
        // Clear the lock after React has processed the update
        setTimeout(() => {
          isViewModeChangingRef.current = false;
        }, 100);
      } else if (pageVal === 'chat' && value && isViewModeChangingRef.current) {
        // Ignore attempts to set map view while we're transitioning to list view
        return;
      } else {
        setMapViewEnabledInternal(value);
      }
    },
    [pageVal]
  );
  const [wasMapViewEnabled, setWasMapViewEnabled]: any = useState<boolean>(pageVal === 'chat' ? true : false);
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(true);
  // State to track view transitions to prevent button flicker
  const [isViewTransitioning, setIsViewTransitioning] = useState<boolean>(false);

  // Listen for chat view mode changes (from "View all properties" button)
  useEffect(() => {
    if (pageVal !== 'chat') return;

    const handleChatViewModeChange = (event: CustomEvent<{ mode: 'grid' | 'map' }>) => {
      // Only update state - DOM side effects are handled by the existing useEffect
      if (event.detail.mode === 'grid') {
        setISMapViewEnabled(false);
      } else {
        setISMapViewEnabled(true);
      }
    };

    window.addEventListener('chat-view-mode-change', handleChatViewModeChange as EventListener);
    return () => {
      window.removeEventListener('chat-view-mode-change', handleChatViewModeChange as EventListener);
    };
  }, [pageVal]);

  const [isMobileState, setIsMobile] = useState(CommonUtils.isOnlyMobileView());
  //check loading of current result
  // For chat context, don't show loading state initially (map should show immediately)
  const [isLoadingSearchResult, setIsLoadingSearchResult] = useState<boolean>(pageVal === 'chat' ? false : true);

  //set search result errors in global state if any
  const [searchResultAlertsState, setSearchResultAlertsState] = useState<SearchResultAlertType>(
    SearchPageAlerts.default
  );

  // Get zustand store for SearchResultAlert
  const zustandStore = useSearchResultAlertZustandStore();
  const featureFlags = useClientEnvVarsStore(state => state.envVarsObject['featureFlags']) as unknown as Record<
    string,
    FLAG_TYPE
  >;
  const shouldUseZustandForSERP = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

  // Create the appropriate setSearchResultAlerts function and state based on flag
  const searchResultAlerts = shouldUseZustandForSERP ? zustandStore.searchResultAlerts : searchResultAlertsState;

  const setSearchResultAlerts = useCallback(
    (alerts: SearchResultAlertType) => {
      if (shouldUseZustandForSERP) {
        // When zustand is enabled, update zustand store
        zustandStore.setSearchResultAlerts(alerts);
      } else {
        // When zustand is disabled, update context state
        setSearchResultAlertsState(alerts);
      }
    },
    [shouldUseZustandForSERP, zustandStore]
  );

  // Create unified setSearchQuery that conditionally updates either Context or Zustand store
  const setSearchQuery = useCallback(
    (action: any) => {
      if (shouldUseZustandForSERP) {
        // When Zustand flag is ON, use Zustand store's setSearchQuery
        // The store's setSearchQuery internally handles all action types via reducer
        searchFilterStore.setSearchQuery(action);
      } else {
        // When Zustand flag is OFF, use Context reducer
        setSearchQueryReducer(action);
      }
    },
    [shouldUseZustandForSERP]
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [recentlyViewed, setRecentlyViewed]: any = useState<any>([]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [featureSelected, setFeatureSelected]: any = useState<boolean>(false);
  const [distance, setDistance] = useState<number>(
    parseFloat(completeSession?.data?.AriesSearch?.searchCriteria?.searchRadius)
  );
  const [numberOfNights, setNumberOfNights] = useState<number>(
    sessionData?.data
      ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.lengthOfStay
      : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.lengthOfStay
  );

  const SPECIAL_RATE_TYPE_NONE = 'none';
  const LOWEST_REGULAR_RATE_LABEL = 'Lowest Regular Rate';
  const [isSpecialRateSearch, setIsSpecialRateSearch]: any = useState<boolean>(false);
  const specialRatesState = useSearchFormStore(state => state[SPECIAL_RATES]);
  const setSearchFormState = useSearchFormStore(state => state.setSearchFormState);
  const setIsCurrencyCallFailed = useSearchFormStore(state => state.setIsCurrencyCallFailed);

  const isFlexibleSearchType =
    pageVal === 'chat'
      ? false
      : (completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate ||
          !completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate ||
          searchQueryData?.options?.endDate === searchQueryData?.options?.startDate) &&
        completeSession?.data?.AriesSearch?.searchCriteria?.searchType !== 'Keyword';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isFlexibleDateSearch, setIsFlexibleDateSearch]: any = useState<boolean>(
    pageState?.authorMode || isAuthorMode ? false : isFlexibleSearchType
  );
  const [leisureRegionValue, setLeisureRegionValue] = useState<string>(
    completeSession?.data?.AriesSearch?.searchCriteria?.address?.region
      ? completeSession?.data?.AriesSearch?.searchCriteria?.address?.region
      : ''
  );
  const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
  const showFullPriceInSession = sessionDataObject?.AriesSearch?.searchCriteria?.showFullPrice;
  const isFlexibleDateSearchRef = useRef<boolean>(isFlexibleSearchType ? true : false);
  const modalRefElement = useRef<any>();
  const skipSearchTriggerFromRetryReset = useRef<boolean>(false);
  const skipUpdateOnCurrencyFallback = useRef<boolean>(false);
  // Skip session-update useEffect after Zustand batchUpdate (store already has correct state)
  const skipSessionUpdateRef = useRef<boolean>(false);
  // Skip duplicate UXL useEffect trigger caused by isSearchClicked resetting to false
  const skipNextSearchEffectRef = useRef<boolean>(false);
  const concurCodeAlreadyApplied = useRef<boolean>(false);
  // Track "Update Search clicked" via ref in Zustand path to avoid isSearchClicked React state
  // being a separate useEffect trigger from the Zustand batch (which would cause double UXL calls)
  const isUpdateSearchClickedRef = useRef<boolean>(false);

  const nightsCount = numberOfNights;

  // maintain search query global state with update/get
  const [searchQueryState, setSearchQueryReducer] = useReducer(
    UpdateSearchState,
    getInitialSearchMockState(
      searchQueryData,
      isSOOEnabled,
      currentLocale,
      segmentId,
      stateSearchFromSession,
      sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
      isFlexibleDateSearch,
      sooOptions,
      isGeographicSearchEnabled
    )
  );

  // Use Zustand store's searchQueryState when flag is enabled, otherwise use reducer state
  // This ensures all references to searchQueryState in this component use the correct source
  // zustandSearchQueryState subscription will trigger re-renders when store updates
  const activeSearchQueryState = shouldUseZustandForSERP ? zustandSearchQueryState : searchQueryState;

  const [pointsChecked, setPointsChecked] = useState<boolean>(activeSearchQueryState[SearchFacetsConstants.points]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isSearchClicked, setIsSearchClicked]: any = useState<boolean>(false);

  const [isFilterChange, setISFilterChange] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isErrorState, setIsErrorState]: any = useState<boolean>(true);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [imageURL, setImageURL]: any = useState<string>('');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isLastCardProcessed, setIsLastCardProcessed]: any = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isStateOrCountry, setIsStateOrCountry]: any = useState<boolean>(false);
  const isLargeDesktop = useCheckBreakpoint('viewportXl');
  const isDesktop = useCheckBreakpoint('viewportL');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [continueCtaProperty, setContinueCtaProperty]: any = useState(
    completeSession?.data
      ? completeSession?.data?.AriesReservation?.propertyId
      : completeSession?.cacheData?.data?.AriesReservation?.propertyId
  );

  const consumerID = completeSession?.data ? completeSession?.data?.consumerID : null;
  const accessToken = completeSession?.data ? completeSession?.data?.accessToken : null;
  const sessionTokenFromCompleteSession =
    sessionData?.data?.sessionToken || sessionData?.key || getSessionIDFromCookie() || '';
  const sessionID = completeSession?.data ? sessionTokenFromCompleteSession : null;
  const rewardsID = completeSession?.data ? completeSession?.data?.rewardsId : null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [sessionObject, setSessionObject]: any = useState({
    consumerID: consumerID,
    accessToken: accessToken,
    sessionID: sessionID,
    rewardsId: rewardsID,
  });

  //consumerID for LAR queries
  const custNumber = useRef<string>(consumerID || '');

  const [keywordSearch, setKeywordSearch] = useState(
    completeSession?.data?.AriesSearch?.searchCriteria?.searchType === 'Keyword'
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [revisionToken, setRevisionToken]: any = useState<any>('');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [savedProperties, setSavedProperties]: any = useState<any>([]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filterUpdateData, setFilterUpdateData] = useState<any>();

  // When running in chat context, the NLS filter query returns fresh facets via the
  // aiFilterUpdateData prop. Sync it into internal filterUpdateData state so that
  // FiltersComponent re-renders with updated bucket counts.
  // This is a chat-only path — shop page never passes aiFilterUpdateData so this
  // useEffect is a no-op for the shop page and does not affect shop functionality.
  useEffect(() => {
    if (pageVal === 'chat' && aiFilterUpdateData) {
      setFilterUpdateData(aiFilterUpdateData);
    }
  }, [aiFilterUpdateData, pageVal]);

  // When running in chat context, populate searchQueryState with the NLP-entity
  // derived pre-selections so that:
  //   1. Each filter sub-component renders matching checkboxes as checked.
  //   2. allFilters' getFilterCount() returns the correct badge number for the
  //      "All Filters" button.
  //
  // We dispatch SearchActions.setApplyFilter for each facet type that has
  // pre-selected values. This is the same action shop uses when the user clicks
  // "Apply" in the filter modal — so it integrates cleanly with the existing
  // searchQueryState reducer without any shop-page impact (aiPreSelectedFacets
  // is undefined on the shop page).
  //
  // When aiPreSelectedFacets transitions to undefined (switching to a message with
  // no NLP filters), we explicitly clear all facets so stale selections from the
  // previous message don't carry over. We skip the clear on initial mount
  // (prevAiPreSelectedFacetsRef.current stays null) to avoid unnecessary dispatches.
  const prevAiPreSelectedFacetsRef = useRef<typeof aiPreSelectedFacets>(null);
  useEffect(() => {
    if (pageVal !== 'chat') return;

    const prev = prevAiPreSelectedFacetsRef.current;
    prevAiPreSelectedFacetsRef.current = aiPreSelectedFacets;

    if (!aiPreSelectedFacets || Object.keys(aiPreSelectedFacets).length === 0) {
      // Only clear when transitioning from a non-null/non-undefined previous value.
      // Skipping on initial mount (prev === null) avoids redundant dispatches since
      // the reducer already initializes with empty facets.
      if (prev !== null && prev !== undefined) {
        const clearState = getSearchFilterClearState();
        Object.entries(clearState).forEach(([facetType, emptyObj]) => {
          setSearchQuery({
            type: SearchActions.setApplyFilter,
            payload: { [facetType]: emptyObj },
          });
        });
      }
      return;
    }

    const facetMap = aiPreSelectedFacets as Record<string, Record<string, string>>;
    Object.entries(facetMap).forEach(([facetType, selectedObj]) => {
      if (Object.keys(selectedObj).length === 0) return;
      setSearchQuery({
        type: SearchActions.setApplyFilter,
        payload: { [facetType]: selectedObj },
      });
    });
    // Re-run only when the pre-selected facets reference changes (i.e. a new NLS
    // search result with different nlpEntities arrives). pageVal and setSearchQuery
    // are stable but included for React Compiler compliance.
  }, [aiPreSelectedFacets, pageVal, setSearchQuery]);

  useEffect(() => {
    if (pageVal === 'chat' && ampRequest) {
      setSearchQuery({
        type: SearchActions.updateQueryAndOtherSearchQueryParam,
        payload: {
          [SearchFacetsConstants.search]: {
            ...searchQueryData?.search,
            [SearchFacetsConstants.options]: {
              ...searchQueryData?.options,
              rateRequestTypes:
                ampRequest?.productQueriesHospitality?.priceModifiers?.rateRequest?.map((rateRequest: any) => ({
                  type: rateRequest?.rateRequestTypeEnum || '',
                  value: rateRequest?.rateRequestValue || '',
                })) || [],
            },
          },
        },
      });
    }
  }, [ampRequest, pageVal, searchQueryData, setSearchQuery]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValues, setFormValues] = useState<any>({});
  const [isAutoSuggestSelectedSearch, setIsAutoSuggestSelectedSearch] = useState<boolean>(false);
  const [isRecentViewSelectedSearch, setIsRecentViewSelectedSearch] = useState<boolean>(false);
  //state to detect error scenario
  const [errorScenario, setErrorScenario] = useState<boolean>(false);
  const [retryFailedWithWarn1000, setRetryFailedWithWarn1000] = useState<boolean>(false);
  const [hasRetried, setHasRetried] = useState<boolean>(false);
  const [warnRates1000RelatedWarningBlock, setWarnRates1000RelatedWarningBlock] = useState<{
    code?: string;
    devMessage?: string;
    message?: string;
  }>({});
  const [isStateOrCountrySearch, setIsStateOrCountrySearch] = useState<boolean>(stateSearchFromSession);
  const [isDestinationSearch, setIsDestinationSearch] = useState<boolean>(false);
  const [hiddenDestData, setHiddenDestData] = useState<any>(
    completeSession?.data?.AriesSearch?.searchCriteria?.address
  );
  // Ref to track the latest hiddenDestData synchronously for use in async callbacks
  // (React state setters are async so closures may read stale values)
  const hiddenDestDataRef = useRef<any>(completeSession?.data?.AriesSearch?.searchCriteria?.address);
  const [isTaxesandFeesIncludedFromPopup, setIsTaxesandFeesIncludedFromPopup] = useState<boolean>(false);
  const [fusionSearchId, setFusionSearchId] = useState<string>('');
  const [sessionIdValue, setSessionIdValue] = useState<string>(
    sessionData?.data?.sessionToken || sessionData?.key || getSessionIDFromCookie() || ''
  );
  const [viewChangeButtonClicked, setViewChangeButtonClicked] = useState<boolean>(false);
  const [fetchCurrencyConversionFactors, setFetchCurrencyConversionFactors] = useState<boolean>(false);
  const [isCorpCodeEntered, setIsCorpCodeEntered] = useState<boolean>(false);
  const [isInitialSearchCall, setIsInitialSearchCall] = useState<boolean>(true);
  const [targetSegmentCallCompleted, setTargetSegmentCallCompleted] = useState<boolean>(false);
  const [isConcurCodeFetched, setIsConcurCodeFetched] = useState<boolean>(false);
  const initialSearchTriggered = useRef<boolean>(false);

  // Initialize SearchResults renderedData Zustand store
  useEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    if (shouldUseZustand) {
      // Initialize the store with current rendered data values (even if jsonContent is initially empty)
      const storeData = {
        jsonContent: jsonContent || {},
        configData,
        isMapViewEnabled,
        recentlyViewed,
        featureSelected,
        isFlexibleDateSearch,
        isSearchClicked,
        isStateOrCountry,
        continueCtaProperty,
        sessionObject,
        revisionToken,
        savedProperties,
        formValues,
        isSpecialRateSearch,
        isAutoSuggestSelectedSearch,
        isRecentViewSelectedSearch,
        isErrorState,
        isLastCardProcessed,
        imageURL,
        isTaxesandFeesIncludedFromPopup,
        isStaticMap,
        isMapLoading,
      };

      // Read live store state to avoid stale closure — child effects (e.g. HotelCard)
      // may have already set isErrorState to false before this parent effect runs.
      const liveIsErrorState = useSearchResultsRenderedDataStore.getState().isErrorState;
      if (liveIsErrorState === true) {
        useSearchResultsRenderedDataStore.getState().initializeSearchResultsRenderedData(storeData);
      }
    }
  }, [
    envVarsObject,
    jsonContent,
    configData,
    isMapViewEnabled,
    recentlyViewed,
    featureSelected,
    isFlexibleDateSearch,
    isSearchClicked,
    isStateOrCountry,
    continueCtaProperty,
    sessionObject,
    revisionToken,
    savedProperties,
    formValues,
    isSpecialRateSearch,
    isAutoSuggestSelectedSearch,
    isRecentViewSelectedSearch,
    isErrorState,
    isLastCardProcessed,
    imageURL,
    isTaxesandFeesIncludedFromPopup,
    isStaticMap,
    isMapLoading,
  ]);

  // Synchronize isMapViewEnabled with Zustand store when it changes
  useEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    if (shouldUseZustand) {
      useSearchResultsRenderedDataStore.getState().setISMapViewEnabled(isMapViewEnabled);
    }
  }, [isMapViewEnabled, envVarsObject]);

  useEffect(() => {
    //Can not remove these selectors, As these selectors are from AEM header component.
    const staticHeaderLogo = document.querySelector('.m-header__thin-logo-icon');
    const staticHeader = document.querySelector('.m-header__thin-container');
    staticHeaderLogo &&
      staticHeaderLogo.addEventListener('click', () => {
        sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'false');
      });
    if (staticHeader) {
      staticHeader.setAttribute('style', 'z-index:5');
    }
    const screenWidth = window.innerWidth;
    const searchUrlParams = new URLSearchParams(window.location.search);
    if (!searchUrlParams?.has('deviceType')) {
      searchUrlParams.set('deviceType', screenWidth < 992 ? 'mobile-web' : 'desktop-web');
      window.history.replaceState({}, '', decodeURIComponent(`?${searchUrlParams.toString()}`));
    }
  }, []);

  useEffect(() => {
    if (
      REWARDS_REDEMPTION_CLUSTER_CODES_HQV.includes(
        formValues?.specialRates?.corporateCode?.toLocaleUpperCase() ||
          sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode?.toLocaleUpperCase()
      )
    ) {
      setIsCorpCodeEntered(true);
    } else {
      setIsCorpCodeEntered(false);
    }
  }, [formValues?.specialRates?.corporateCode]);

  const callSegmentApi = async () => {
    const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
    const segmentPayload = targetPayloadRequest(
      {
        isUxl: 'false',
        mboxName: process.env['TARGET_SEGMENT_MBOX_NAME'] || clientEnvVars['TARGET_SEGMENT_MBOX_NAME'],
        propertyToken: process.env['TARGET_SEGMENT_PROPERTY_TOKEN'] || clientEnvVars['TARGET_SEGMENT_PROPERTY_TOKEN'],
      },
      {
        env_site_id: window?.['dataLayer']?.['env_site_id'],
        search_destination_type: sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
        page_url_query_string: sessionDataObject?.AriesCommon?.page_url_query_string,
        search_destination_lat_long:
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude &&
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.longitude
            ? `${sessionDataObject.AriesSearch.searchCriteria.address.latitude},${sessionDataObject.AriesSearch.searchCriteria.address.longitude}`
            : '',
      }
    );
    segmentPayload.id.tntId = getShopTntId(window?.['dataLayer']);
    const consumerId = sessionData?.cacheData?.data?.consumerID ?? sessionData?.data?.consumerID;
    if (consumerId) {
      segmentPayload.id.thirdPartyId = consumerId;
    }
    try {
      const response = await Axios.post(
        headersData?.serpv1 === 'true' ? TARGET_SEGMENT_API_ENDPOINT_V1 : TARGET_SEGMENT_API_ENDPOINT,
        {
          targetReqPayload: segmentPayload,
        }
      );
      const segmentIdValue = response?.data?.segmentId;
      setSegmentId(response?.data?.segmentId);
      setTargetSegmentCallCompleted(true);
      if (
        isRecommendedSortSegmentId(segmentIdValue) &&
        !isStateOrCountrySearch &&
        !determineExclusionCriteriaForSortOptions(
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude,
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
          sessionDataObject?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate
        )
      ) {
        setSearchQuery({
          type: SearchActions.updateQueryAndOtherSearchQueryParam,
          payload: {
            [SearchFacetsConstants.sort]: {
              fields: [
                {
                  field: RECOMMENDED_OPTION,
                  direction: SearchSortFieldsDirection.desc,
                },
              ],
            },
          },
        });
      }
    } catch (error) {
      setTargetSegmentCallCompleted(true);
      throw error; // Propagate the error up for handling
    }
  };

  useEffect(() => {
    if (sessionObject?.consumerID && sessionObject?.accessToken) {
      consumeRevisionToken();
    }
    if (window && window?.dataLayer) {
      const currentDate = moment();
      const startDate = completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate;
      const endDate = completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate;
      const diffFromStartDate = Math.abs(moment.duration(currentDate.diff(startDate)).asDays() ?? 0);
      const diffFromEndDate = Math.abs(moment.duration(currentDate.diff(endDate)).asDays() ?? 0);
      // set availability checkbox true or false basis of search object
      const isIncludeUnAvailableProperties = diffFromStartDate > 6 || diffFromEndDate > 6 ? true : false;
      window.dataLayer['search_show_available_hotels'] = !isIncludeUnAvailableProperties;
    }
  }, []);

  useEffect(() => {
    // eslint-disable-line react-hooks/exhaustive-deps, react-compiler/react-compiler
    const searchOject = activeSearchQueryState[SearchFacetsConstants.search];
    // Use hiddenDestDataRef (updated synchronously in updateSearchResultsData) instead of
    // completeSession (stale page-load prop) so exclusion works after Update Search
    const destinationType = hiddenDestDataRef.current?.destinationType;
    if (
      destinationType !== SearchGeographicDestinationTypes.Country &&
      destinationType !== SearchGeographicDestinationTypes.State_Province_Region &&
      destinationType !== SearchGeographicDestinationTypes.Leisure_Region &&
      searchQueryData?.latitude &&
      !searchOject?.[SearchFacetsConstants.latitude]
    ) {
      // Create a new object instead of mutating the existing one
      // This is important for Zustand stores which use Immer's Draft objects
      const updatedSearchObject = {
        ...searchOject,
        [SearchFacetsConstants.latitude]: searchQueryData?.latitude,
        [SearchFacetsConstants.longitude]: searchQueryData?.longitude,
        [SearchFacetsConstants.destination]: undefined,
      };

      setSearchQuery({
        type: SearchActions.updateQueryAndOtherSearchQueryParam,
        payload: {
          [SearchFacetsConstants.search]: updatedSearchObject,
        },
      });
    }
    // activeSearchQueryState is intentionally NOT in dependencies to prevent infinite loops
    // The guard condition (!searchOject?.[latitude]) ensures this only runs once when latitude is missing
  }, [searchQueryData, setSearchQuery]);

  // Handle dataLayer updates for sort order based on current criteria
  useEffect(() => {
    const latitude = searchQueryData?.latitude || 0;
    const destinationType = completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType || '';
    const flexibleDate = isFlexibleDateSearch;

    if (
      !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
      isRecommendedSortSegmentId(segmentId) &&
      window?.dataLayer
    ) {
      window.dataLayer['search_list_setting_sort_order'] = RECOMMENDED_OPTION?.toLowerCase();
    }
  }, [
    searchQueryData?.latitude,
    completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType,
    isFlexibleDateSearch,
    segmentId,
  ]);

  // Helper function to update dataLayer safely
  // UseEffect to handle dataLayer update when search counter changes
  useEffect(() => {
    if (updateSearchCounter > 0 && window?.dataLayer) {
      window.dataLayer['updates_search_call_counter'] = updateSearchCounter.toString();
    }
  }, [updateSearchCounter]);

  // UseEffect to handle DOM side effects and dataLayer when map view changes
  useEffect(() => {
    if (!isMapViewEnabled) {
      // Handle DOM manipulations as side effects when switching to list view
      document.body.style.overflow = 'auto';
      const searchFormEl = document.getElementById('document_search_form_container_el_ref');
      if (searchFormEl) {
        searchFormEl.classList.remove('map-view-sticky');
      }
      // Update dataLayer for list view
      if (window?.dataLayer) {
        window.dataLayer['search_results_view'] = 'List View';
      }
    } else {
      // Handle DOM manipulations as side effects when switching to map view
      // This ensures overflow is hidden even when state is managed by Zustand
      document.body.style.overflow = 'hidden';
      // Ensure sessionStorage is set so other components (SearchFormComponent, HQVWrapper)
      // don't reset overflow to 'auto' when closing modals
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'true');
      }
      // Update dataLayer for map view
      if (window?.dataLayer) {
        window.dataLayer['search_results_view'] = 'Map View';
      }
    }
    // Cleanup: restore scroll on unmount so no other page is permanently locked
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMapViewEnabled]);

  const displayDefaultError = (e?: any, data?: any) => {
    if (pageVal !== 'chat') {
      Axios.post(loggerApiURL, {
        message: `SearchResults component UXL error for sessionId ${sessionID}: ${inspect(e)}`,
      });
    }
    setIsLoadingSearchResult(false);
    // Checking if we should display the stubborn error message
    if (
      (!data || !data.total || data?.total === 0) &&
      !data?.status?.[0]?.errors?.[0]?.code &&
      !data?.status?.[0]?.warnings?.[0]?.code
    ) {
      setSearchResultAlerts(
        getAlertsData(jsonContent?.alertsListArray && jsonContent?.alertsListArray[0]?.alertCodeListModel[0], 'info')
      );
    }
  };

  const getMediaTourFromUXL = async (allid: any) => {
    /**
     * get all media by property id
     */
    try {
      const { data, error } = await getMedia({
        variables: {
          ids: allid,
          limitPerCategory: 2,
        },
        context: {
          headers: {
            'x-b3-traceId': searchQueryData?.sessionToken ?? 'fallback-token',
            'x-b3-spanId': requestId,
            'x-request-id': requestId,
            'accept-language': currentLocale,
          },
        },
      });
      if (data) {
        setSearchResult({
          type: SearchActions.updateMedia,
          payload: {
            media: data.propertiesByIds,
          },
        });

        // Sync with Zustand store when flag is ON
        if (shouldUseZustandForSERP) {
          const { updateMediaData } = useSearchResultsStore.getState();
          updateMediaData(data.propertiesByIds);
        }

        if (pageVal === 'chat') {
          onPropertyMediaLoaded?.(data.propertiesByIds || []);
        }
      }
      if (error) {
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
          });
        }
      }
    } catch (e) {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(e)}`,
        });
      }
    }
  };

  const loadCurrencyOnceResultLoaded = async (data: any) => {
    /**
     * load all price currency once we get the result
     */
    let currencyListArr: Array<string> | undefined;
    data?.forEach((edge: any) => {
      const ratesNode = edge?.node?.rates;
      /**fetch rates nodes accroding to api */
      if (ratesNode && Object.keys(ratesNode).length > 0) {
        /**
         * filter rate node as per the usage
         */
        const currRateNode = getCurrentPriceRateBlock(activeSearchQueryState, ratesNode);
        const currRate = getCurrRateAmountBlock(currRateNode);
        const currencyInfo = currRate?.amount;
        if (currencyInfo && currencyInfo.currency) {
          /**
           * store different currency info in a local var
           */
          if (currencyListArr && currencyListArr.indexOf(currencyInfo?.currency) === -1) {
            /**
             * set another currency if we have
             */
            currencyListArr.push(currencyInfo?.currency);
            return; // empty return statement to break further execution
          }
          if (currencyListArr === undefined) {
            /**
             * set first currency
             */
            currencyListArr = [currencyInfo?.currency];
            return; // empty return statement to break further execution
          }
        }
      }
    });
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentOriginCurrency: currencyListArr,
      },
    });
    if (
      (isInitialLoad && activeSearchQueryState.currentCurrency !== DefaultValue) ||
      (activeSearchQueryState.currentCurrency !== DefaultValue &&
        activeSearchQueryState.currentCurrency === activeSearchQueryState.currentAppliedCurrency &&
        fetchCurrencyConversionFactors)
    ) {
      /**
       * if we have diffrent currency on search load
       */
      !skipQuery && (await getDataWithCurrencyFilterApplied(currencyListArr));
      return; // empty return statement to break further execution
    }
    return; // empty return statement to break further execution
  };

  const errorHandler = async (errorHandlerPayload: {
    _res: any;
    incorrectDestinationErrorCode: any;
    filtersHidden: any;
    paginationHidden: any;
    incorrectDestinationWarningCode: any;
    totalFilterCount: any;
    incorrectDestinationWarningBlock: any;
  }) => {
    const {
      _res,
      incorrectDestinationErrorCode,
      filtersHidden,
      paginationHidden,
      incorrectDestinationWarningCode,
      totalFilterCount,
      incorrectDestinationWarningBlock,
    } = errorHandlerPayload;
    if (
      (_res?.status?.[0]?.errors?.[0]?.code &&
        !propertyCardHiddenCodes?.includes(incorrectDestinationErrorCode) &&
        (filtersHidden || paginationHidden)) ||
      propertyCardHiddenCodes?.includes(incorrectDestinationWarningCode)
    ) {
      filtersHidden?.classList.add('filters-container-hidden');
      paginationHidden?.classList.add('filters-container-hidden');
      //flag to to detect error
      setErrorScenario(true);
    }

    // Keeping both warnings and errors in the condition to ensure that both are displayed
    if (_res?.status?.[0]?.errors?.[0]?.code || _res?.status?.[0]?.warnings?.[0]?.code) {
      /**
       * error cases if we get result 0
       */
      if (totalFilterCount && !_res?.total) {
        setIsLoadingSearchResult(false);
        setSearchResultAlerts(
          getAlertsData(
            jsonContent?.alertsListArray?.filter(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (key: any) => key.alertMsgTypeName === clearAllFilterKey
            )[0]?.alertCodeListModel[0],
            'warning'
          )
        );
        setWasMapViewEnabled(isMapViewEnabled);

        // Check feature flag to determine if we should sync with Zustand store
        const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
        const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

        // Update local React state (always needed for main component logic)
        setISMapViewEnabled(false);
        // Also update Zustand store if feature flag is enabled
        if (shouldUseZustand) {
          searchResultsRenderedDataStore.setISMapViewEnabled(false);
        }
        document.body.style.overflow = 'auto';
        sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'false');
      } else {
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `SearchResults component totalFilterCount and _res?.total for sessionId ${sessionID}: ${totalFilterCount}, ${_res?.total}`,
          });
        }
        //errors will be shown based on the respective conditions which satisfies
        if (completeSession?.data?.AriesSearch?.searchCriteria?.searchType === 'NearAddress') {
          //To update error key in session doc
          await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
            'search-error-messages|search.form.near.address.property.result.not.found',
          ]);
          //to set the error message
          setSearchResultAlerts(
            getAlertsData(
              jsonContent?.alertsListArray?.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (key: any) => key.alertMsgTypeName === noNearAddressKey
              )[0]?.alertCodeListModel[0],
              'search.form.near.address.property.result.not.found'
            )
          );
        } else {
          const errorBlockLength = _res?.status?.[0]?.errors ? _res?.status?.[0]?.errors.length : 0;
          const warningBlockLength = _res?.status?.[0]?.warnings ? _res?.status?.[0]?.warnings.length : 0;
          for (let errorBlockIterator = 0; errorBlockIterator < errorBlockLength; errorBlockIterator++) {
            const errorBlock = _res?.status?.[0]?.errors?.[errorBlockIterator];
            if (!validErrorCodes?.includes(errorBlock?.code)) {
              continue;
            }
            switch (errorBlock?.code ?? '') {
              case 'LAR-1001':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|no.hotels.within.radius.error.msg',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === noHotelsWithinRadiusKey
                    )?.[0]?.alertCodeListModel[0],
                    'no.hotels.within.radius.error.msg'
                  )
                );
                break;
              case 'LAR-1002':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|no.availability.within.radius.error.msg',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === noAvailabilityKey
                    )[0]?.alertCodeListModel[0],
                    'no.availability.within.radius.error.msg'
                  )
                );
                break;
              case 'LAR-1003':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|property.search.hotels.maxcapacity.not.available',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === maxCapacityKey
                    )[0]?.alertCodeListModel[0],
                    'property.search.hotels.maxcapacity.not.available'
                  )
                );
                break;
              // Displays default error message if new error code is detected. Not passing data object to ensure if condition passes
              default:
                if (_res?.status?.[0]?.errors?.[0]?.code) {
                  displayDefaultError(_res?.status?.[0]?.errors?.[0]?.code);
                }
            }
          }
          if (incorrectDestinationWarningBlock) {
            //To update error key in session doc
            await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
              'search-error-messages|no.hotels.within.radius.error.msg',
            ]);
            //to set the error message
            setSearchResultAlerts(
              getAlertsData(
                jsonContent?.alertsListArray?.filter(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (key: any) => key.alertMsgTypeName === noHotelsWithinRadiusKey
                )?.[0]?.alertCodeListModel[0],
                'no.hotels.within.radius.error.msg'
              )
            );
            //flag to to detect error
            setErrorScenario(true);
          } else {
            let sessionCode = '';
            let aemFilterKey = '';
            let alertCode = '';
            let alertPriority = 100;
            let isErrorScenario = false;
            let endUserAlertMessage = '';
            for (let warningBlockIterator = 0; warningBlockIterator < warningBlockLength; warningBlockIterator++) {
              const warningBlock = _res?.status?.[0]?.warnings?.[warningBlockIterator];
              if (!validWarningCodes?.includes(warningBlock?.code)) {
                continue;
              }
              let currentPriority = 101;
              // to call warning scenarios based on UXL response
              switch (warningBlock?.code ?? '') {
                // letting the LAR-1002 case fall through since we do not get results from UXL in BAU and hence, filters must be hidden.
                // In DTT UXL, we get results so the if condition is not required.
                case 'LAR-1002':
                case 'AMP181':
                case 'WARN-RATES-1000':
                  if (warningBlock?.code.includes('AMP')) {
                    currentPriority = AMPAlertPriority;
                  } else {
                    currentPriority = SERPAlertPriority;
                  }
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = 'search-error-messages|no.availability.within.radius.error.msg';
                    aemFilterKey = noAvailabilityKey;
                    alertCode =
                      warningBlock?.code === 'AMP181' || warningBlock?.code === 'WARN-RATES-1000'
                        ? warningBlock?.code
                        : 'no.availability.within.radius.error.msg';
                    endUserAlertMessage =
                      warningBlock?.code === 'AMP181' || warningBlock?.code === 'WARN-RATES-1000'
                        ? warningBlock?.message
                        : '';
                    isErrorScenario = true;
                  }
                  break;
                case 'queries.v2.properties.limit.range.dev.2':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = '';
                    aemFilterKey = tooManyPropertiesErrorKey;
                    alertCode = 'queries.v2.properties.limit.range.dev.2';
                    endUserAlertMessage = '';
                    isErrorScenario = false;
                  }
                  break;
                case 'WARN-RATES-1001':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = '';
                    aemFilterKey = noAvailabilityKey;
                    alertCode =
                      warningBlock?.code === 'WARN-RATES-1001'
                        ? warningBlock?.code
                        : 'queries.v2.properties.limit.range.dev.2';
                    endUserAlertMessage = warningBlock?.code === 'WARN-RATES-1001' ? warningBlock?.message : '';
                    isErrorScenario = false;
                  }
                  break;
                case 'WARN-SEARCH-1002':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = 'search-error-messages|no.hotels.within.radius.error.msg';
                    aemFilterKey = noHotelsWithinRadiusKey;
                    alertCode =
                      warningBlock?.code === 'WARN-SEARCH-1002'
                        ? warningBlock?.code
                        : 'no.hotels.within.radius.error.msg';
                    endUserAlertMessage = warningBlock?.code === 'WARN-SEARCH-1002' ? warningBlock?.message : '';
                    isErrorScenario = true;
                  }
                  // to add hidden class to filter and pagination
                  filtersHidden?.classList.add('filters-container-hidden');
                  paginationHidden?.classList.add('filters-container-hidden');
                  break;
                default:
                  break;
              }
            }
            if (alertPriority < 100) {
              if (sessionCode !== '') {
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  sessionCode,
                ]);
              }
              if (isErrorScenario) {
                //flag to to detect error
                setErrorScenario(true);
              }
              //to set the error message
              setSearchResultAlerts(
                getAlertsData(
                  ErrorFrameworkCodeArray.includes(alertCode)
                    ? {
                        alertLinkTextLabel: endUserAlertMessage.match(LinkMatchRegex)?.[1] || '',
                        alertMessageLabel: endUserAlertMessage.replace(LinkMatchRegex, '${AlertLinkTextLabel}'),
                      }
                    : jsonContent?.alertsListArray?.filter(
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (key: any) => key.alertMsgTypeName === aemFilterKey
                      )[0]?.alertCodeListModel[0],
                  alertCode
                )
              );
            }
          }
        }
      }
    }
    if (_res?.total && isUnsuccessfulUserJourney()) {
      const alert = jsonContent?.alertsListArray?.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key: any) => key.alertMsgTypeName === unsuccessfulSellKey
      )[0];
      setSearchResultAlerts(getAlertsData(alert?.alertCodeListModel[0], 'UnsuccessfulSell'));
    }
    setIsLoadingSearchResult(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadSearchResults = async (data: any): Promise<void> => {
    const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
    const flexibleDate = sessionDataObject?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate;
    const latitude = sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude;
    const destinationType = sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType;
    //Can not remove these selectors, As these selectors are from different component.
    const filtersHidden = document.querySelector('.filter-component');
    const paginationHidden = document.querySelector('.pagination-sort-container');
    const _res = data;
    await loadCurrencyOnceResultLoaded(_res.edges); // load currency post search result
    // responseDataFromLoadSearchResults = data;
    const dataLayerObj = window.dataLayer ?? {};
    try {
      //removes the filters hidden class if no error shows up
      if (filtersHidden || paginationHidden) {
        filtersHidden?.classList.remove('filters-container-hidden');
        paginationHidden?.classList.remove('filters-container-hidden');
      }
      setErrorScenario(false);
      if (shouldUseZustandForSERP) {
        searchResultsRenderedDataStore.setIsStateOrCountry(
          activeSearchQueryState && activeSearchQueryState?.search?.latitude
            ? false
            : _res?.searchCenter === null || _res?.searchCenter?.latitude === null || !_res?.searchCenter
        );
      }
      setIsStateOrCountry(
        activeSearchQueryState && activeSearchQueryState?.search?.latitude
          ? false
          : _res?.searchCenter === null || _res?.searchCenter?.latitude === null || !_res?.searchCenter
      );
      const totalFilterCount = getTotalFilterCount(activeSearchQueryState);
      const sortByOptions =
        !isStateOrCountry && !isFlexibleDateSearch
          ? isSOOEnabled &&
            !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
            isRecommendedSortSegmentId(segmentId)
            ? pointsChecked
              ? 'recommended,distance,city,points,brand'
              : 'recommended,distance,city,price,brand'
            : pointsChecked
            ? 'distance,city,points,brand'
            : 'distance,city,price,brand'
          : !isStateOrCountry && isFlexibleDateSearch
          ? isSOOEnabled &&
            !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
            isRecommendedSortSegmentId(segmentId)
            ? 'recommended,distance,city,brand'
            : 'distance,city,brand'
          : isStateOrCountry && isFlexibleDateSearch
          ? 'city,brand'
          : pointsChecked
          ? 'city,points,brand'
          : 'city,price,brand';

      localStorage.setItem('sortByOptions', sortByOptions);
      updateDataLayerObj(
        dataLayerObj,
        _res,
        activeSearchQueryState,
        isFlexibleDateSearch,
        isMapViewEnabled,
        datalayerProperties,
        isAutoSuggestSelectedSearch,
        isRecentViewSelectedSearch,
        sortByOptions,
        headersData?.referer,
        activeSearchQueryState?.includeUnavailableProperties
      );
      let localSearchCounterValue;
      if (sessionStorage.getItem('updateSearchCounter')) {
        const sessionValue = sessionStorage.getItem('updateSearchCounter');
        const maxValue = Math.max(parseInt(sessionValue as string), updateSearchCounter);
        setUpdateSearchCounter(maxValue + 1);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
        localSearchCounterValue = (maxValue + 1).toString();
      } else {
        sessionStorage.setItem('updateSearchCounter', `${updateSearchCounter}`);
        localSearchCounterValue = updateSearchCounter;
      }
      dataLayerObj['updates_search_call_counter'] = localSearchCounterValue;
      // Update the window.location.hash with the update search counter
      window.history.replaceState({}, headersData?.referer as string, `#/${localSearchCounterValue}/`);
      setSearchResult({
        /**
         * set search result for the user query
         */
        type: SearchActions.setSearchResultData,
        payload: {
          pageInfo: _res?.pageInfo,
          total: _res?.total,
          edges: _res?.edges,
          searchCenter: _res?.searchCenter,
          facets: _res?.facets,
          geoCodeInfo: _res?.geoCodeInfo,
          llmMetadata: _res?.llmMetadata,
          messageUiData: messageUiData,
        },
      });

      // Sync with Zustand store when flag is ON
      if (shouldUseZustandForSERP) {
        const { setSearchResultData } = useSearchResultsStore.getState();
        setSearchResultData({
          pageInfo: _res?.pageInfo,
          total: _res?.total,
          edges: _res?.edges,
          searchCenter: _res?.searchCenter,
          facets: _res?.facets,
          geoCodeInfo: _res?.geoCodeInfo,
          llmMetadata: _res?.llmMetadata,
          messageUiData: messageUiData,
        });
      }

      setSearchQuery({
        /**set filter/facets for the search result */
        type: SearchActions.setFilter,
        payload: _res?.facets,
      });

      //filters and pagination are hidden if error shows
      const incorrectDestinationWarningBlock = _res?.status?.[0]?.warnings?.find(
        (warning: any) => warning.code === 'WARN-SEARCH-1006'
      );
      const incorrectDestinationErrorBlock = _res?.status?.[0]?.errors?.find((error: any) => error.code === 'LAR-1001');
      const incorrectDestinationWarningCode = incorrectDestinationWarningBlock?.code ?? '';
      const incorrectDestinationErrorCode = incorrectDestinationErrorBlock?.code ?? '';
      errorHandler({
        _res,
        incorrectDestinationErrorCode,
        filtersHidden,
        paginationHidden,
        incorrectDestinationWarningCode,
        totalFilterCount,
        incorrectDestinationWarningBlock,
      });
    } catch (e) {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `SearchResults component UXL catch error for sessionId ${sessionID}: ${inspect(e)}`,
        });
      }
      setSearchResultAlerts(
        getAlertsData(jsonContent?.alertsListArray && jsonContent?.alertsListArray[0]?.alertCodeListModel[0], 'info')
      );
      //handle error at this place for any call
      setIsLoadingSearchResult(false);
    }
  };

  const renderedDataValue = useMemo(
    () => ({
      jsonContent,
      configData,
      isMapViewEnabled,
      setISMapViewEnabled,
      GOOGLE_MAP_API_KEY,
      recentlyViewed,
      setRecentlyViewed,
      featureSelected,
      setFeatureSelected,
      isFlexibleDateSearch,
      setIsFlexibleDateSearch,
      isSearchClicked,
      setIsSearchClicked,
      isStateOrCountry,
      setIsStateOrCountry,
      continueCtaProperty,
      setContinueCtaProperty,
      sessionObject,
      setSessionObject,
      revisionToken,
      setRevisionToken,
      savedProperties,
      setSavedProperties,
      isSpecialRateSearch,
      setIsSpecialRateSearch,
      formValues,
      setFormValues,
      isAutoSuggestSelectedSearch,
      setIsAutoSuggestSelectedSearch,
      isRecentViewSelectedSearch,
      setIsRecentViewSelectedSearch,
      isErrorState,
      setIsErrorState,
      isLastCardProcessed,
      setIsLastCardProcessed,
      imageURL,
      setImageURL,
      isTaxesandFeesIncludedFromPopup,
      setIsTaxesandFeesIncludedFromPopup,
      isStaticMap,
      isMapLoading,
      messageUiData,
    }),
    [
      jsonContent,
      configData,
      isMapViewEnabled,
      GOOGLE_MAP_API_KEY,
      recentlyViewed,
      featureSelected,
      isFlexibleDateSearch,
      isSearchClicked,
      isStateOrCountry,
      continueCtaProperty,
      sessionObject,
      revisionToken,
      savedProperties,
      isSpecialRateSearch,
      formValues,
      isAutoSuggestSelectedSearch,
      isRecentViewSelectedSearch,
      isErrorState,
      isLastCardProcessed,
      imageURL,
      isTaxesandFeesIncludedFromPopup,
      isStaticMap,
      isMapLoading,
      messageUiData,
    ]
  );

  useEffect(() => {
    setContinueCtaProperty(
      completeSession?.data
        ? completeSession?.data?.AriesReservation?.propertyId
        : completeSession?.cacheData?.data?.AriesReservation?.propertyId
    );
    setIsSpecialRateSearch(
      completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !==
        SPECIAL_RATE_TYPE_NONE ||
        (formValues && formValues?.specialRates && formValues?.specialRates?.clusterCode !== SPECIAL_RATE_TYPE_NONE)
    );
    eventUtil.on('displayLoader', () => {
      setIsLoadingSearchResult(true);
      setSearchResult({
        /**
         * set search result empty
         */
        type: SearchActions.setSearchResultData,
        payload: {
          pageInfo: {},
          total: 0,
          edges: [],
        },
      });

      // Sync with Zustand store when flag is ON
      if (shouldUseZustandForSERP) {
        const { setSearchResultData } = useSearchResultsStore.getState();
        setSearchResultData({
          pageInfo: {},
          total: 0,
          edges: [],
        });
      }
    });
    setUpdatedDestinationType(
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType ??
        completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.address?.destinationType
    );
    return (): void => {
      eventUtil.remove('displayLoader', () => {});
      eventUtil.remove('updateShopPageFormValues', () => {});
    };
  }, []);
  const updateSearchResultsData = (data: any) => {
    setKeywordSearch(false);
    const {
      usePoints,
      searchObj,
      isFlexibleDateSearch,
      formValues,
      destinationHiddenData,
      isAutoSuggestSelected,
      isRecentSearchSelected,
      updatedSessionData,
    } = data;
    setLeisureRegionValue(destinationHiddenData?.region ?? '');
    setIsSpecialRateSearch(
      updatedSessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !==
        SPECIAL_RATE_TYPE_NONE ||
        (formValues && formValues?.specialRates && formValues?.specialRates?.clusterCode !== SPECIAL_RATE_TYPE_NONE)
    );
    if (updatedSessionData) {
      setSessionData(updatedSessionData);
      updateGlobalData('sessionData', updatedSessionData);
      // Directly update Zustand page context store to avoid stale sessionData
      // between React state update and _app.tsx useEffect sync
      if (shouldUseZustandForSERP) {
        updatePageContextVar('sessionData', updatedSessionData);
      }
      setSessionIdValue(
        updatedSessionData?.data?.sessionToken || updatedSessionData?.key || getSessionIDFromCookie() || ''
      );
      const sessionDataObject = updatedSessionData?.data?.AriesSearch?.searchCriteria
        ? updatedSessionData?.data?.AriesSearch?.searchCriteria
        : updatedSessionData?.cacheData?.data?.AriesSearch?.searchCriteria;
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `SearchResults update session Data, Search Criteria ${sessionID}: ${inspect(
            sessionDataObject
          )}, ${inspect(sessionDataObject?.address)}`,
        });
      }
    }
    setHiddenDestData(destinationHiddenData);
    hiddenDestDataRef.current = destinationHiddenData; // Sync ref immediately for async callbacks
    isFlexibleDateSearchRef.current = pageState?.authorMode || isAuthorMode ? false : isFlexibleDateSearch;
    const newIsFlexibleDateSearch = pageState?.authorMode || isAuthorMode ? false : isFlexibleDateSearch;
    setIsFlexibleDateSearch(newIsFlexibleDateSearch);

    // Update Zustand store when feature flag is enabled
    // Use selector to get latest feature flags from store (not captured envVarsObject)
    const featureFlags = useClientEnvVarsStore.getState().envVarsObject?.['featureFlags'] as unknown as
      | Record<string, any>
      | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;
    if (shouldUseZustand) {
      searchResultsRenderedDataStore.setIsFlexibleDateSearch(newIsFlexibleDateSearch);
      // Add comprehensive store synchronization
      searchResultsRenderedDataStore.setFormValues(formValues);
      searchResultsRenderedDataStore.setIsAutoSuggestSelectedSearch(isAutoSuggestSelected);
      searchResultsRenderedDataStore.setIsRecentViewSelectedSearch(isRecentSearchSelected);
      searchResultsRenderedDataStore.setIsSearchClicked(true);
      searchResultsRenderedDataStore.setIsErrorState(true);
      searchResultsRenderedDataStore.setIsLastCardProcessed(false);

      // Reset SearchResultAlert store to default state for new search
      zustandStore.setSearchResultAlerts(SearchPageAlerts.default);

      // SearchFilter store updates are batched at the end of this function
      // to avoid multiple set() calls triggering duplicate UXL queries.

      // Update SavedProperties store if saved data is available
      if (savedData) {
        savedPropertiesDispatchStore.savedPropertiesInitialization(savedData.savedPropertiesList || []);
      }
    }

    setFormValues(formValues);
    setIsAutoSuggestSelectedSearch(isAutoSuggestSelected);
    setIsRecentViewSelectedSearch(isRecentSearchSelected);

    // In Zustand path, track search click via ref instead of React state.
    // setIsSearchClicked(true) as React state would be a separate useEffect dep change
    // from the Zustand batch (activeSearchQueryState.search), causing double UXL calls
    // if React doesn't batch them into one render.
    if (shouldUseZustand) {
      isUpdateSearchClickedRef.current = true;
      concurCodeAlreadyApplied.current = false;
    } else {
      setIsSearchClicked(true);
    }
    const { options, latitude, destination } = searchObj;
    const { startDate, endDate } = options;
    if (shouldUseZustand) {
      searchResultsRenderedDataStore.setIsStateOrCountry(latitude !== null || leisureRegionValue ? false : true);
    }
    setIsStateOrCountry(latitude !== null || leisureRegionValue ? false : true);
    const searchCriteriaObj = updatedSessionData?.data?.AriesSearch?.searchCriteria
      ? updatedSessionData?.data?.AriesSearch?.searchCriteria
      : updatedSessionData?.cacheData?.data?.AriesSearch?.searchCriteria;
    setNumberOfNights(
      searchCriteriaObj?.availabilityRequestVO?.lengthOfStay ??
        Math.ceil(moment(formValues?.dates?.toDate)?.diff(formValues?.dates?.fromDate, 'days', true) ?? 0)
    );
    setPointsChecked(usePoints);
    setFeatureSelected(false);
    setIsErrorState(true);
    setIsLastCardProcessed(false);
    setDistance(parseFloat(destinationHiddenData?.radius ?? searchCriteriaObj?.searchRadius));

    if (usePoints) {
      //reset price filter if we have applied any
      if (!shouldUseZustandForSERP) {
        setSearchQuery({ type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.price]: {} } });
      }
    } else {
      //reset price filter if we have applied any
      if (!shouldUseZustandForSERP) {
        setSearchQuery({ type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.points]: {} } });
      }
    }

    if (
      isGeographicSearchEnabled &&
      (destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.State_Province_Region ||
        destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.Country ||
        destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.Leisure_Region)
    ) {
      setIsStateOrCountrySearch(true);
    } else if (
      destination &&
      !destinationHiddenData?.city &&
      ((destinationHiddenData?.state && destinationHiddenData?.state?.split(',').length > 0) ||
        (destinationHiddenData?.country && destinationHiddenData?.country?.split(',').length > 0) ||
        (destinationHiddenData?.region && destinationHiddenData?.region?.split(',').length > 0))
    ) {
      setIsStateOrCountrySearch(true);
    } else {
      setIsStateOrCountrySearch(false);
      if (!shouldUseZustand) {
        if (destinationHiddenData.state) {
          setSearchQuery({
            type: SearchActions.setApplyFilter,
            payload: {
              [SearchFacetsList.states]: {},
            },
          });
        } else {
          setSearchQuery({
            type: SearchActions.setApplyFilter,
            payload: {
              [SearchFacetsList.countries]: {},
            },
          });
        }
      }
    }

    const currentDate = moment(); // current date
    const diffFromStartDate = Math.abs(moment.duration(currentDate.diff(startDate)).asDays() ?? 0);
    const diffFromEndDate = Math.abs(moment.duration(currentDate.diff(endDate)).asDays() ?? 0);
    // set availability checkbox true or false basis of search object
    const isIncludeUnAvailableProperties = diffFromStartDate > 6 || diffFromEndDate > 6 ? true : false;
    setUpdatedDestinationType(searchCriteriaObj?.address?.destinationType);

    if (shouldUseZustand) {
      // For Zustand: Batch ALL searchFilterStore updates into a single set() call
      // to produce one store notification and one React render. Multiple separate
      // set() calls would each trigger the useEffect that fires UXL queries,
      // causing duplicate API calls.
      try {
        const batchActions: { type: any; payload: any }[] = [
          // 1. Set the search query (includes destination, options, lat/lng etc.)
          { type: SearchActions.setQuery, payload: searchObj },
          // 2. Reset price or points filter
          usePoints
            ? { type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.price]: {} } }
            : { type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.points]: {} } },
          // 3. Update taxes and availability
          {
            type: SearchActions.updateTaxesAndAvailability,
            payload: {
              [SearchFacetsConstants.includeTaxes]: searchCriteriaObj?.showFullPrice === 'true' ? true : false,
            },
          },
          // 4. The comprehensive update with sort, offset, goToNextPage, points, search, currency
          {
            type: SearchActions.updateQueryAndOtherSearchQueryParam,
            payload: {
              [SearchFacetsConstants.unavailableProperties]: isIncludeUnAvailableProperties,
              [SearchFacetsConstants.offset]: 0,
              [SearchFacetsConstants.goToNextPage]: 0,
              [SearchFacetsConstants.sort]: {
                fields: fetchSortFields(
                  searchCriteriaObj?.address?.latitude,
                  searchCriteriaObj?.address?.destinationType,
                  formValues?.dates?.flexible === 'true' || formValues?.dates?.flexible === true ? true : false
                ),
              },
              [SearchFacetsConstants.points]: usePoints,
              [SearchFacetsConstants.search]: searchObj,
              currentCurrency: DefaultValue,
              currentOriginCurrency: [],
              currentAppliedCurrency: DefaultValue,
            },
          },
        ];

        // 5. Conditionally add states/countries filter reset
        if (
          !(
            isGeographicSearchEnabled &&
            (destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.State_Province_Region ||
              destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.Country ||
              destinationHiddenData?.destinationType === SearchGeographicDestinationTypes.Leisure_Region)
          ) &&
          !(
            destination &&
            !destinationHiddenData?.city &&
            ((destinationHiddenData?.state && destinationHiddenData?.state?.split(',').length > 0) ||
              (destinationHiddenData?.country && destinationHiddenData?.country?.split(',').length > 0) ||
              (destinationHiddenData?.region && destinationHiddenData?.region?.split(',').length > 0))
          )
        ) {
          // Not a state/country search — clear state or country filter
          if (destinationHiddenData.state) {
            batchActions.push({
              type: SearchActions.setApplyFilter,
              payload: { [SearchFacetsList.states]: {} },
            });
          } else {
            batchActions.push({
              type: SearchActions.setApplyFilter,
              payload: { [SearchFacetsList.countries]: {} },
            });
          }
        }

        searchFilterStore.batchUpdate(batchActions);
        // Prevent the session-update useEffect from overwriting the store
        // (the batch already set the correct state; session call would reconstruct stale data)
        skipSessionUpdateRef.current = true;
      } catch (error) {
        console.error('Error updating SearchFilter store in updateSearchResultsData:', error);
      }
    } else {
      // For Context: Update the taxes and fees in search options based on the session data response
      setSearchQuery({
        type: SearchActions.updateTaxesAndAvailability,
        payload: {
          [SearchFacetsConstants.includeTaxes]: searchCriteriaObj?.showFullPrice === 'true' ? true : false,
        },
      });

      setSearchQuery({
        type: SearchActions.updateQueryAndOtherSearchQueryParam,
        payload: {
          // set availability checkbox true or false basis of search object
          [SearchFacetsConstants.unavailableProperties]: isIncludeUnAvailableProperties,
          [SearchFacetsConstants.offset]: 0,
          [SearchFacetsConstants.goToNextPage]: 0,
          [SearchFacetsConstants.sort]: {
            fields: fetchSortFields(
              searchCriteriaObj?.address?.latitude,
              searchCriteriaObj?.address?.destinationType,
              formValues?.dates?.flexible === 'true' || formValues?.dates?.flexible === true ? true : false
            ),
          },
          // change this to above line if these is any change
          [SearchFacetsConstants.points]: usePoints, //remove seperate statement and add these into single update function
          [SearchFacetsConstants.search]: searchObj,
          //comment below lines if you want to presist the currency filter
          currentCurrency: DefaultValue,
          currentOriginCurrency: [],
          currentAppliedCurrency: DefaultValue,
        },
      });
    }
  };

  useEffect(() => {
    eventUtil.on('updateShopPageFormValues', data => {
      /**
       * on update search click from old searchform
       */
      updateSearchResultsData(data);
    });
    /**
     * Event to capture the user values from baseline search form
     */

    //To-do : Remove this event once we have migrated context to zustand
    eventUtil.on('updateBaselineSearchFormValues', data => {
      /**
       * on update search click from baseline searchform
       */
      updateSearchResultsData(data);
    });
    return (): void => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      eventUtil.remove('updateShopPageFormValues', () => {});
      eventUtil.remove('updateBaselineSearchFormValues', () => {});
      eventUtil.remove('displayLoader', () => {});
    };
  }, []);

  const setDataToContext = (data: any, error: any): void => {
    /******* set data/error to context  */
    /*** remove code duplication  */
    if (
      (error || !data || !data.total || data?.total === 0) &&
      !data?.status?.[0]?.errors?.[0]?.code &&
      !data?.status?.[0]?.warnings?.[0]?.code
    ) {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `SearchResults component setDataToContext error for sessionId ${sessionID}: ${inspect(error)}`,
        });
      }
      displayDefaultError(error, data);
    }
    if (data) {
      setISFilterChange(false);
      loadSearchResults(data);
    }
  };
  const fetchSortFields = (latitude: number, destinationType: string, flexibleDate: boolean) => {
    // sort options for hotellist=marsha and boost brand combined scenario
    if (
      !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
      isRecommendedSortSegmentId(segmentId)
    ) {
      // DataLayer update will be handled by useEffect
      return [
        {
          field: RECOMMENDED_OPTION,
          direction: SearchSortFieldsDirection.desc,
        },
      ];
    } else if (enableHotelList() === true && enableBoostBrands() === true) {
      return [
        {
          field: 'BRAND',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else if (enableHotelList() === true) {
      return [
        {
          field: 'PROPERTY_NAME',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else if (
      (isGeographicSearchEnabled &&
        destinationType &&
        ![
          SearchGeographicDestinationTypes.Country,
          SearchGeographicDestinationTypes.State_Province_Region,
          SearchGeographicDestinationTypes.Leisure_Region,
        ].includes(destinationType as SearchGeographicDestinationTypes)) ||
      (!isGeographicSearchEnabled && latitude)
    ) {
      return [
        {
          field: 'DISTANCE',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else {
      return SearchSortFieldForDISTANCE?.map((fieldVal: any) => {
        return {
          field: fieldVal,
          direction: SearchSortFieldsDirection.asc,
        };
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ifLeisureRegionApplicable = (searchPayload: any, currentIsStateOrCountry?: boolean) => {
    //logic to handle leisureRegions if navigated from homepage , or else regular destination flow will work
    // Use passed-in value (fresh computation) when available, fall back to React state
    const isStateOrCountry = currentIsStateOrCountry ?? isStateOrCountrySearch;

    //if state or country search and destination is availabe , remove destination
    if (
      isStateOrCountry &&
      searchPayload.search.destination &&
      searchPayload.search.destination !== completeSession?.data?.AriesSearch?.searchCriteria?.airportCode
    ) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { destination, ...searchWithoutDestination } = searchPayload.search;
      searchPayload.search = searchWithoutDestination;
    }

    //if region is available in sessiondata , add leisure region to payload
    if (leisureRegionValue !== '') {
      if (
        searchPayload &&
        searchPayload.search &&
        searchPayload.search.destination &&
        isFlexibleDateSearchRef.current
      ) {
        searchPayload.search.destination = '';
      }
    } else {
      //if not state or country search , and destination is available on state , assign it to payload
      if (activeSearchQueryState?.search?.destination && !isStateOrCountry) {
        searchPayload.search.destination = activeSearchQueryState?.search?.destination;
      }
    }

    // remove destination from search payload in case no destination given for hotellist deeplink
    let hasDestinationParam = false;
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      hasDestinationParam =
        params?.has('destinationAddress.destination') && params?.get('destinationAddress.destination') !== '';
    }

    if (enableHotelList() === true && !hasDestinationParam && searchPayload?.search?.destination) {
      if (searchPayload.search) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { destination, ...searchWithoutDestination } = searchPayload.search;
        searchPayload.search = searchWithoutDestination;
      }
    }
  };

  const loadSearchResultsData = async (
    response: {
      fusionSearchId: string | undefined;
      searchQueryId: string | undefined;
    },
    sessionIdValue: string,
    recipeID?: string,
    isSearchFallback?: boolean,
    searchFallbackType?: string
  ) => {
    // calling datalayer app after API success so that we can pass fusion ID that we recieve from UXL to datalayer
    await callDataLayerOnFeatureChanges(
      resolvedUrl,
      headersData,
      query,
      datalayerParams,
      sessionIdValue,
      response.searchQueryId,
      currentLocale,
      searchDestinationTypeForDatalayerRef.current,
      recipeID,
      isSearchFallback,
      searchFallbackType
    );
    setDataToContext(response, null);
  };

  const resetSpecialRatesToLowestRegularRate = () => {
    setSearchFormState([SPECIAL_RATES], {
      [SPECIAL_RATES]: {
        ...(specialRatesState ?? {}),
        specialRateCode: SPECIAL_RATE_TYPE_NONE,
        clusterCode: LOWEST_REGULAR_RATE_LABEL,
        corporateCode: '',
      },
    });
    // Sync rateRequestTypes to activeSearchQueryState so pagination/filters use LRR
    setSearchQuery({
      type: SearchActions.updateQueryAndOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.search]: {
          ...(activeSearchQueryState[SearchFacetsConstants.search] ?? {}),
          [SearchFacetsConstants.options]: {
            ...(activeSearchQueryState[SearchFacetsConstants.search]?.[SearchFacetsConstants.options] ?? {}),
            rateRequestTypes: LOWEST_REGULAR_RATE_REQUEST_TYPES,
          },
        },
      },
    });
    // Update legacy search form (non-NG) if present.
    eventUtil.dispatch('resetSpecialRatesToLowestRegularRate', {});
    setIsSpecialRateSearch(false);
    // Prevent Concur code from being re-applied on page refresh after WARN-RATES-1000 fallback
    setConcurUserOverride();
  };

  //Handle response from search result
  const handleResponse = async (
    res: {
      data: { searchLowestAvailableRatesByDestination: any; searchPropertiesByDestination: any; search: any };
      isSearchFallback: boolean;
      searchFallbackType: string;
      retryHasWarn1000?: boolean;
      retryCallwithLrr?: boolean;
      warnRates1000RelatedWarningBlock?: { code?: string; devMessage?: string; message?: string };
    },
    isDesti: boolean,
    isFlexibleDateSearch: boolean,
    isStateOrCountrySearch: boolean | undefined,
    sessionIdValue: string,
    isAirport?: boolean,
    sooModel?: string
  ) => {
    // Only update retry-related state when response contains retry data (from retry scenario)
    // Sort/pagination responses lack these - preserve existing state so alert stays visible
    if (res && 'retryCallwithLrr' in res) {
      setHasRetried(Boolean(res?.retryCallwithLrr));
      if (res?.retryHasWarn1000) {
        setRetryFailedWithWarn1000(true);
      } else {
        setRetryFailedWithWarn1000(false);
      }
      setWarnRates1000RelatedWarningBlock(res?.warnRates1000RelatedWarningBlock ?? {});
    }

    const response =
      pageVal === 'chat'
        ? res?.data?.search?.conversationalSearch?.searchByNaturalLanguageQuery || {}
        : extractDataFromDTTResponse(res.data.search, isDesti, isFlexibleDateSearch, isStateOrCountrySearch, isAirport);
    if (!suppressListUntilMapReady) {
      setHidePropertyList(false);
    }
    setInitialLoad(false);
    setSearchResultsState([RATES_DATA], {
      [RATES_DATA]: { [RATES_DATA]: response },
    });

    const recipeID = getRecipeId(sooModel, response?.recipeId, isFlexibleDateSearch);
    /*
                Dispatches the searchCenter address field so as to Update
                the destination field value with searchCenter address, if destination query triggers.
                */
    if (
      (res.data?.searchLowestAvailableRatesByDestination ||
        res.data?.searchPropertiesByDestination ||
        res.data?.search?.properties?.searchByDestination ||
        res.data?.search?.lowestAvailableRates?.searchByDestination) &&
      response?.searchCenter !== null
    ) {
      eventUtil.dispatch('SearchResultsData', response?.searchCenter);
    }
    const allIDs = getAllPropertyIDS(response?.edges);
    if (allIDs?.length) {
      getMediaTourFromUXL(allIDs);
    }

    // updating fusionId if we are getting it from response that we will pass to datalayer
    setFusionSearchId(response.searchQueryId ?? '');
    if (
      !isLocalDev &&
      !['zh-CN', 'zh-TW'].includes(currentLocale) &&
      !completeSession?.data?.AriesSearch?.searchCriteria?.destinationAddressPlaceId &&
      !completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType &&
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.destination
    ) {
      try {
        const geoCoderResponse = await geoCodeAddress(
          completeSession.data.AriesSearch.searchCriteria.address.destination
        );
        const destinationTypeValue = getSearchDestinationTypeAnalytics(geoCoderResponse?.types);
        setSearchDestinationTypeForSession(destinationTypeValue);
        searchDestinationTypeForDatalayerRef.current = destinationTypeValue;
      } catch (err) {
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `SearchResults component geocoder.geocode call failed for destination ${
              completeSession.data.AriesSearch.searchCriteria.address.destination
            }: ${inspect(err)}`,
          });
        }
      }
    }
    loadSearchResultsData(response, sessionIdValue, recipeID, res?.isSearchFallback, res?.searchFallbackType);
  };

  //Search Result Data call START
  const getSearchDataOnAnyUIChanges = async (): Promise<void> => {
    try {
      // When Zustand flag is ON, read from store; otherwise use local state
      const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
      const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;
      const currentIsFlexibleDateSearch = shouldUseZustand
        ? searchResultsRenderedDataStore.isFlexibleDateSearch
        : isFlexibleDateSearch;

      // Compute isStateOrCountrySearch fresh from hiddenDestDataRef to avoid stale closure.
      // When called from the useEffect triggered by activeSearchQueryState.search change,
      // setIsStateOrCountrySearch from updateSearchResultsData may not have been committed yet.
      // hiddenDestDataRef.current is updated synchronously in updateSearchResultsData.
      const currentHiddenDestData = hiddenDestDataRef.current;
      const currentIsStateOrCountrySearch =
        isGeographicSearchEnabled &&
        (currentHiddenDestData?.destinationType === SearchGeographicDestinationTypes.State_Province_Region ||
          currentHiddenDestData?.destinationType === SearchGeographicDestinationTypes.Country ||
          currentHiddenDestData?.destinationType === SearchGeographicDestinationTypes.Leisure_Region)
          ? true
          : !!activeSearchQueryState?.search?.destination &&
            !currentHiddenDestData?.city &&
            !!(
              (currentHiddenDestData?.state && currentHiddenDestData?.state?.split(',').length > 0) ||
              (currentHiddenDestData?.country && currentHiddenDestData?.country?.split(',').length > 0) ||
              (currentHiddenDestData?.region && currentHiddenDestData?.region?.split(',').length > 0)
            );

      const searchVar = getSearchResultQuery(
        activeSearchQueryState,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        currentIsFlexibleDateSearch,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        sooOptions,
        currentHiddenDestData.destinationType,
        isGeographicSearchEnabled
      );

      let searchPayload = Object.assign({}, searchVar);
      let isDesti =
        searchVar.search.destination !== undefined &&
        searchVar.search.destination !== null &&
        searchVar.search.destination !== '';
      // For state/country/leisure-region searches, force isDesti true so that
      // getShopQueryForSearchInput builds LocationSearchInput facets and
      // getDatedPropertyInfo selects phoenixShopDatedSearchByLocationSearchInputQuery
      // instead of phoenixShopDatedSearchByGeoQuery. The form's searchObj may omit
      // destination for geographic searches (by design), but the query type must
      // still be LocationSearchInput.
      if (currentIsStateOrCountrySearch) {
        isDesti = true;
      }
      setIsDestinationSearch(isDesti);
      if (isInitialLoad && !suppressListUntilMapReady) {
        setHidePropertyList(false);
      }
      if (isDesti && currentIsStateOrCountrySearch) {
        searchPayload = await getShopQueryForSearchInput(
          searchVar,
          currentHiddenDestData,
          activeSearchQueryState,
          currentIsFlexibleDateSearch,
          currentLocale,
          isSOOEnabled,
          sooOptions,
          isGeographicSearchEnabled
        );
      }
      ifLeisureRegionApplicable(searchPayload, currentIsStateOrCountrySearch);
      let isAirport = false;
      if (
        searchPayload?.search?.destination?.toLowerCase() ===
        completeSession?.data?.AriesSearch?.searchCriteria?.airportCode?.toLowerCase()
      ) {
        isAirport = true;
      }
      const payload = {
        variables: {
          ...searchPayload,
        },
        ...queryCommonContext,
      };

      // Get search fallback exists flag & type value
      const AriesCommon = sessionData?.cacheData?.data?.AriesCommon ?? sessionData?.data?.AriesCommon;
      const searchFallbackExistsCustomerCall: boolean = AriesCommon?.search_fallback_exists_customer_call;
      const searchFallbackTypeCustomerCall: string = AriesCommon?.search_fallback_type_customer_call;

      /****
       * create graphql call flexible/dated */
      if (currentIsFlexibleDateSearch) {
        const UXLqueryPayloadData = {
          resolvedUrl,
          headersData,
          query,
          datalayerParams,
          sessionIdValue,
          currentLocale,
          apolloClientRef,
          setSearchResultsState,
          params: payload,
          queryCallback: 'getFlexiblePropertyInfo',
          onRetrySpecialRatesReset: () => {
            skipSearchTriggerFromRetryReset.current = true;
            resetSpecialRatesToLowestRegularRate();
          },
          isFlexibleDateSearch: currentIsFlexibleDateSearch,
          isDestinationSearch: isDesti,
          isStateOrCountrySearch: currentIsStateOrCountrySearch,
          isAirport,
          searchFallbackExistsCustomerCall,
          searchFallbackTypeCustomerCall,
          sessionData,
        };
        executeUXLQueries(UXLqueryPayloadData).then(
          (res: any) => {
            if (res) {
              handleResponse(
                res,
                isDesti,
                currentIsFlexibleDateSearch,
                currentIsStateOrCountrySearch,
                sessionIdValue,
                isAirport,
                sooModel
              );
            }
          },
          (error: any) => {
            if (error) {
              setDataToContext(null, error);
              if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
                callDataLayerForSearchFallback(
                  resolvedUrl,
                  headersData,
                  query,
                  datalayerParams,
                  sessionIdValue,
                  currentLocale,
                  false,
                  UXL_COMPLETE_FAIL
                );
              }
              updatePageContextVar('resultsRetried', false);
              if (pageVal !== 'chat') {
                Axios.post(loggerApiURL, {
                  message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
                });
              }
            }
          }
        );
      } else {
        const UXLqueryPayloadData = {
          resolvedUrl,
          headersData,
          query,
          datalayerParams,
          sessionIdValue,
          currentLocale,
          apolloClientRef,
          setSearchResultsState,
          params: payload,
          queryCallback: 'getDatedPropertyInfo',
          onRetrySpecialRatesReset: () => {
            skipSearchTriggerFromRetryReset.current = true;
            resetSpecialRatesToLowestRegularRate();
          },
          isFlexibleDateSearch: currentIsFlexibleDateSearch,
          isDestinationSearch: isDesti,
          isStateOrCountrySearch: currentIsStateOrCountrySearch,
          isAirport,
          searchFallbackExistsCustomerCall,
          searchFallbackTypeCustomerCall,
          sessionData,
        };
        executeUXLQueries(UXLqueryPayloadData).then(
          (res: any) => {
            if (res) {
              handleResponse(
                res,
                isDesti,
                currentIsFlexibleDateSearch,
                currentIsStateOrCountrySearch,
                sessionIdValue,
                undefined,
                sooModel
              );
            }
          },
          (error: any) => {
            if (error) {
              setDataToContext(null, error);
              if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
                callDataLayerForSearchFallback(
                  resolvedUrl,
                  headersData,
                  query,
                  datalayerParams,
                  sessionIdValue,
                  currentLocale,
                  false,
                  UXL_COMPLETE_FAIL
                );
              }
              updatePageContextVar('resultsRetried', false);
              if (pageVal !== 'chat') {
                Axios.post(loggerApiURL, {
                  message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
                });
              }
            }
          }
        );
      }
      eventUtil.dispatch('loadSearchForm', true);
    } catch (e) {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `SearchResults component getSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
            e
          )}`,
        });
      }
      displayDefaultError(e);
    }
  };

  //Keyword Search Result Data call START
  const getKeywordSearchDataOnAnyUIChanges = async () => {
    try {
      if (!suppressListUntilMapReady) {
        setHidePropertyList(false);
      }
      const searchVar = getSearchResultQuery(
        activeSearchQueryState,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        isFlexibleDateSearch,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        sooOptions,
        hiddenDestData.destinationType,
        isGeographicSearchEnabled
      );
      const searchQuery = {
        limit: 40,
        offset: 0,
        search: {
          keyword: completeSession?.data?.AriesSearch?.searchCriteria?.keywordSearchRequestVO?.keywords,
          options: {
            ...searchVar?.search?.options,
            startDate: `${
              currentLocale === hardCodedAllLocale.ar
                ? convertArabicToEnglishNumbers(moment().format('YYYY-MM-DD'))
                : currentLocale === hardCodedAllLocale.hi
                ? convertHindiToEnglishNumbers(moment().format('YYYY-MM-DD'))
                : moment().format('YYYY-MM-DD')
            }`,
            endDate: `${
              currentLocale === hardCodedAllLocale.ar
                ? convertArabicToEnglishNumbers(moment().add(1, 'days').format('YYYY-MM-DD'))
                : currentLocale === hardCodedAllLocale.hi
                ? convertHindiToEnglishNumbers(moment().add(1, 'days').format('YYYY-MM-DD'))
                : moment().add(1, 'days').format('YYYY-MM-DD')
            }`,
          },
        },
      };
      const UXLqueryPayloadData = {
        resolvedUrl,
        headersData,
        query,
        datalayerParams,
        sessionIdValue,
        currentLocale,
        apolloClientRef,
        setSearchResultsState,
        params: {
          variables: {
            ...searchQuery,
          },
          ...queryCommonContext,
        },
        queryCallback: 'getKeywordPropertyInfo',
        sessionData,
      };
      const { data, error } = await executeUXLQueries(UXLqueryPayloadData);
      if (data) {
        setDataToContext(data.searchLowestAvailableRatesByKeyword, error);
        const allIDs = getAllPropertyIDS(data.searchLowestAvailableRatesByKeyword?.edges);
        if (allIDs?.length) {
          getMediaTourFromUXL(allIDs);
        }
      }
      if (error) {
        if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
          callDataLayerForSearchFallback(
            resolvedUrl,
            headersData,
            query,
            datalayerParams,
            sessionIdValue,
            currentLocale,
            false,
            UXL_COMPLETE_FAIL
          );
        }
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `SearchResults component getKeywordSearchDataOnAnyUIChanges error for sessionId ${sessionID}: ${inspect(
              error
            )}`,
          });
        }
        updatePageContextVar('resultsRetried', false);
        displayDefaultError(error, data?.searchLowestAvailableRatesByKeyword);
      }
    } catch (e) {
      updatePageContextVar('resultsRetried', false);
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `SearchResults component getKeywordSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
            e
          )}`,
        });
      }
      displayDefaultError(e);
    }
  };
  const getCurrencyData = async (currency: string) => {
    if (currency === activeSearchQueryState.currentCurrency) {
      return {
        currentConversionRate: 1,
        currentConversionRateDecimalPoint: 1,
        currency: currency,
      };
    }

    const payloadObj = {
      input: {
        inputCurrencyISOCode: currency, // currency we have on property card
        outputCurrencyISOCode: activeSearchQueryState?.currentCurrency?.toUpperCase(), //currency selected by user
        date: getESTDate(), //todays date
      },
    };

    let data;
    try {
      const response = await getCurrencyConversionRate({
        variables: payloadObj,
        ...queryCommonContext,
      });
      data = response.data;
    } catch (error) {
      log.debug(`Currency conversion error: ${inspect(error)}`);
      // Return default values on error
      return {
        currentConversionRate: 1,
        currentConversionRateDecimalPoint: 0,
        currency: currency,
        isCurrencyConversionFallback: true,
      };
    }

    if (data?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case update currency
      setViewChangeButtonClicked(true);
    }

    return {
      currentConversionRate:
        data?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate /
        Math.pow(10, data?.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint),
      currentConversionRateDecimalPoint: data?.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint,
      currency: currency,
      isCurrencyConversionFallback: false,
    };
  };
  const getDataWithCurrencyFilterApplied = async (currencyArr?: Array<string> | undefined) => {
    const currencyList = currencyArr ?? activeSearchQueryState.currentOriginCurrency;
    if (currencyList) {
      try {
        const data = await Promise.all(currencyList.map(getCurrencyData));

        // Check if any currency conversion had a fallback
        const isCurrencyConversionFallback = data.some(item => item.isCurrencyConversionFallback === true);

        if (isCurrencyConversionFallback) {
          setIsCurrencyCallFailed?.(true);
          // Prevent one automatic UXL/session refresh caused by fallback currency reset.
          skipUpdateOnCurrencyFallback.current = true;
          // Force default currency when conversion fails, without currency-conversion side effects.
          setSearchQuery({
            type: SearchActions.updateCurrency,
            payload: {
              currentCurrency: DefaultValue,
              currentAppliedCurrency: DefaultValue,
            },
          });
          updateQueryParams(
            {
              selectedCurrency: DefaultValue,
            },
            ['selectedCurrency'],
            headersData?.referer
          );
          setSearchResultAlerts(
            getAlertsData(
              jsonContent?.alertsListArray?.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (key: any) => key.alertMsgTypeName === 'alertCurrencyConversionFailed'
              )[0]?.alertCodeListModel[0],
              'warning'
            )
          );
        } else {
          setIsCurrencyCallFailed?.(false);
          setSearchQuery({
            /**
             * update currency conversion rate based on the currency selected
             */
            type: SearchActions.updateCurrency,
            payload: {
              currentConversionRate: data,
              currentAppliedCurrency: activeSearchQueryState.currentCurrency, // set user current currency
            },
          });
        }
        if (isFilterChange) {
          // call query function also if user has changed the filter with currency
          if (keywordSearch) {
            getKeywordSearchDataOnAnyUIChanges();
          } else {
            getSearchDataOnAnyUIChanges();
          }
        } else {
          if (!isInitialLoad && !isCurrencyConversionFallback) {
            if (sessionStorage.getItem('updateSearchCounter')) {
              const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
              sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
            } else {
              sessionStorage.setItem('updateSearchCounter', '0');
            }
            const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
            setUpdateSearchCounter(parseInt(searchCounterValue || '0', 10));
            // Update the window.location.hash with the update search counter
            window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
          }
          if (!suppressListUntilMapReady) {
            setHidePropertyList(false); // display property records
          }
          setIsLoadingSearchResult(false); // hide loader
        }
        updateDataLayerObj(
          window?.dataLayer ?? {},
          data,
          activeSearchQueryState,
          isFlexibleDateSearch,
          isMapViewEnabled,
          datalayerProperties,
          isAutoSuggestSelectedSearch,
          isRecentViewSelectedSearch,
          localStorage.getItem('sortByOptions'),
          headersData?.referer,
          activeSearchQueryState?.includeUnavailableProperties
        );

        // Call datalayer API with isSearchFallback: false when currency conversion fails
        if (isCurrencyConversionFallback) {
          await callDataLayerOnFeatureChanges(
            resolvedUrl,
            headersData,
            query,
            datalayerParams,
            sessionID,
            undefined,
            currentLocale,
            undefined,
            undefined,
            true, // isSearchFallback changed to true for currency conversion failure
            'TIP_Currency_Conversion_Failure'
          );
          updateURLHashCounter(headersData, true);
        }
        return; // stop next execution
      } catch (e) {
        log.debug(`currency:function error ${inspect(e)}`);
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `SearchResults component getSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
              e
            )}`,
          });
        }
        return; // stop next execution
      }
    }
    return; // stop next execution
  };

  const getUpdatedFilterOnUSelection = async (event: any) => {
    const payload = event?.detail;
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has('unsuccessfulSell')) {
        params.delete('unsuccessfulSell');
        const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
        window.history.replaceState({}, headersData?.referer, decodeURIComponent(`?${params}#/${searchCounterValue}/`));
      }
      const searchVar = getSearchResultQuery(
        payload,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        isFlexibleDateSearchRef.current,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        sooOptions,
        hiddenDestData.destinationType,
        isGeographicSearchEnabled
      );
      let searchPaylod = Object.assign({}, searchVar);
      let isDesti =
        searchVar.search.destination !== undefined &&
        searchVar.search.destination !== null &&
        searchVar.search.destination !== '';
      // For state/country searches, force isDesti true so that
      // getDatedFilter selects phoenixShopDatedSearchByLocationSearchInputFilterQuery
      // instead of phoenixShopDatedSearchByGeoFilterQuery.
      if (isStateOrCountrySearch) {
        isDesti = true;
      }
      setIsDestinationSearch(isDesti);
      if (isDesti && isStateOrCountrySearch) {
        searchPaylod = await getShopQueryForSearchInput(
          searchVar,
          hiddenDestData,
          payload,
          isFlexibleDateSearchRef.current,
          currentLocale,
          isSOOEnabled,
          sooOptions,
          isGeographicSearchEnabled
        );
        delete searchPaylod.search.destination;
      }
      const load = {
        variables: {
          ...searchPaylod,
        },
        ...queryCommonContext,
      };
      /****
       * create graphql call flexible/dated */
      const { data, error } = isFlexibleDateSearchRef.current
        ? !skipQuery &&
          (await getFlexibleFilter(
            /***
             * flexible search api call
             */
            load,
            isDesti,
            isStateOrCountrySearch
          ))
        : !skipQuery &&
          (await getDatedFilter(
            /***
             * dated search api call
             */
            load,
            isDesti,
            isStateOrCountrySearch
          ));
      if (data) {
        let isAirport = false;
        if (
          searchPaylod?.search?.destination?.toLowerCase() ===
          completeSession?.data?.AriesSearch?.searchCriteria?.airportCode?.toLowerCase()
        ) {
          isAirport = true;
        }
        const res = extractDataFromDTTResponse(
          data.search,
          isDesti,
          isFlexibleDateSearchRef.current,
          isStateOrCountrySearch,
          isAirport
        );
        setFilterUpdateData(res);
      }
      if (error) {
        if (pageVal !== 'chat') {
          Axios.post(loggerApiURL, {
            message: `searchresult:error with UXL filter api for sessionId ${sessionID}: ${inspect(error)}`,
          });
        }
      }
    } catch (e) {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `searchresult:error with UXL filter api for sessionId ${sessionID}: ${inspect(e)}`,
        });
      }
    }
  };

  //need to remove this code once we are donw with client side calling pattern
  useEffect(() => {
    if (pageVal === 'chat') {
      return;
    }
    document.addEventListener('updateShopPageFilterModalValues', getUpdatedFilterOnUSelection); //removeEventListener is not working with eventUtil so using document.addEventListener
    eventUtil.on('observeFilterChangeToUpdateTheDataWithCurrency', () => {
      //listen to this event once currency will change with other filter
      setISFilterChange(true);
    });
    return (): void => {
      // remove all this event
      document.removeEventListener('updateShopPageFilterModalValues', getUpdatedFilterOnUSelection as any);
      eventUtil.remove('observeFilterChangeToUpdateTheDataWithCurrency', () => {});
    };
  }, [getUpdatedFilterOnUSelection, pageVal]);

  useEffect(() => {
    // Skip for chat - ChatMapView uses useJsApiLoader which handles Google Maps loading
    if (pageVal === 'chat') {
      return;
    }
    // Only load Google Maps if API key is available
    if (google_map_api_key && (!window.google || window.google === undefined)) {
      appendMapFile();
    }
  }, [pageVal, google_map_api_key]);
  //function to append google map script to the document with valid map api key before using google geocoder api.
  const appendMapFile = (): void => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&loading=async`;
    script.defer = true;

    document.head.appendChild(script);
  };

  /**
   * get and update latest session
   */
  const getLatestSessionData = async () => {
    const filters = getTotalFilterCount(activeSearchQueryState);
    const lengthOfStayValue: number = nightsCount;

    const fieldsWithValuesTrue = fieldsInteractedInSERP(interactionsSelected);

    const appliedInteractions = interactionsAppliedOnSERP(
      activeSearchQueryState,
      formValues,
      lengthOfStayValue,
      filters,
      featureSelected,
      isFlexibleDateSearch,
      searchResult
    );

    const updatedSessionDoc = await updateSessionDocProperties(
      sessionData?.key ??
        sessionData?.data?.sessionToken ??
        sessionData?.cacheData?.data?.sessionToken ??
        sessionData?.sessionToken ??
        getSessionIDFromCookie(),
      sessionObject?.accessToken,
      SESSION_APP_GET_CALL_URL,
      SESSION_GET_CALL_URL_CLIENT,
      datalayerParams,
      activeSearchQueryState,
      savedProperties,
      appliedInteractions,
      resolvedUrl,
      headersData,
      query,
      fieldsWithValuesTrue,
      isMapViewEnabled,
      fusionSearchId,
      viewChangeButtonClicked,
      currentLocale,
      searchDestinationTypeForSession
    );
    // Update the session data state value
    if (updatedSessionDoc && Object.keys(updatedSessionDoc).length > 0) {
      setSessionData(updatedSessionDoc);
      // Directly update Zustand page context store to avoid stale sessionData
      // between React state update and _app.tsx useEffect sync
      if (shouldUseZustandForSERP) {
        updatePageContextVar('sessionData', updatedSessionDoc);
      }
      setSessionIdValue(updatedSessionDoc?.sessionToken);

      // Add missing Zustand store updates
      const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
      const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

      if (shouldUseZustand) {
        // Update other stores as needed based on session changes
        if (savedData) {
          savedPropertiesDispatchStore.savedPropertiesInitialization(savedData.savedPropertiesList || []);
        }
      }
    }
    setViewChangeButtonClicked(false);
    if (updatedSessionDoc && Object.keys(updatedSessionDoc).length > 0) {
      // Use direct Zustand method if available (when feature flag is ON), otherwise use dispatcher
      if (setPropertySessionData) {
        setPropertySessionData(updatedSessionDoc);
      } else {
        hqvDispatch({ type: HQV_ACTIONS.PROPERTY_SESSION_DATA, payload: updatedSessionDoc });
      }
    }
  };

  useEffect(() => {
    isMapViewEnabled && window?.scrollTo(0, 0); // scroll to top always when map view is enabled
    // currentAppliedCurrency contains the currency the results are currently in
    // currentCurrency contains the value that the user has newly selected
    // adding a condition to prevent redundant updateSession calls on currency change
    // skip getLatestSessionData when update search was clicked - session was already updated by /validate/findHotels

    // Skip session update after Zustand batchUpdate — store already has correct state
    if (skipSessionUpdateRef.current) {
      skipSessionUpdateRef.current = false;
      return;
    }
    if (
      (activeSearchQueryState?.currentAppliedCurrency === activeSearchQueryState?.currentCurrency ||
        activeSearchQueryState?.currentCurrency === DefaultValue) &&
      !isInitialLoad &&
      !isSearchClicked
    ) {
      getLatestSessionData();
    }
    setIsAutoSuggestSelectedSearch(false);
    setIsRecentViewSelectedSearch(false);
  }, [
    activeSearchQueryState.search,
    activeSearchQueryState[SearchFacetsConstants.goToNextPage],
    JSON.stringify(activeSearchQueryState[SearchFacetsConstants.sort]),
    isMapViewEnabled,
    activeSearchQueryState?.currentCurrency,
    activeSearchQueryState?.currentConversionRate,
    activeSearchQueryState?.includeTaxesAndFees,
  ]);

  const getSearchResultMockData = async () => {
    const response = await getMockSearchResultData();
    setSearchResult({
      /**
       * set search result for the user query
       */
      type: SearchActions.setSearchResultData,
      payload: {
        pageInfo: response?.pageInfo,
        total: response?.total,
        edges: response?.edges,
        // searchCenter: response?.searchCenter,
      },
    });

    // Sync with Zustand store when flag is ON
    if (shouldUseZustandForSERP) {
      const { setSearchResultData } = useSearchResultsStore.getState();
      setSearchResultData({
        pageInfo: response?.pageInfo,
        total: response?.total,
        edges: response?.edges,
      });
    }

    //update search facets with mock data
    setSearchQuery({
      type: SearchActions.setFilter,
      payload: response?.facets,
    });
    //disable loading state because we are using mock data
    setIsLoadingSearchResult(false);
    if (!suppressListUntilMapReady) {
      setHidePropertyList(false);
    }
    eventUtil.dispatch('loadSearchForm', true);
  };

  const updateSearchAPICalls = () => {
    /**
     * fetch search result based on search query
     */
    // In Zustand path, isSearchClicked is never set to true (we use isUpdateSearchClickedRef instead)
    // so isSearchClicked is always false here — setIsSearchClicked(false) is a no-op, no skip needed.
    // In Context path, capture and reset as before.
    const isUserUpdateSearchClick = shouldUseZustandForSERP ? isUpdateSearchClickedRef.current : isSearchClicked;
    if (shouldUseZustandForSERP) {
      isUpdateSearchClickedRef.current = false;
    } else {
      // Skip the next useEffect trigger caused by isSearchClicked changing from true to false,
      // which would otherwise fire the UXL useEffect again and cause a duplicate datalayer call.
      if (isSearchClicked) {
        skipNextSearchEffectRef.current = true;
      }
      setIsSearchClicked(false);
    }
    setHidePropertyList(true);
    setIsLoadingSearchResult(true);
    setSearchResultAlerts(SearchPageAlerts.default);
    // Only clear retry-related state when user clicked Update search; preserve during sort/pagination
    if (isUserUpdateSearchClick) {
      setRetryFailedWithWarn1000(false);
      setHasRetried(false);
      setWarnRates1000RelatedWarningBlock({});
    }
    window.scrollTo(0, 0);
    if (pageVal === 'chat' && AiSearchResults) {
      handleResponse(AiSearchResults.rawData, false, false, false, sessionIdValue);
    } else {
      if (!pageState?.authorMode && !isAuthorMode) {
        if (
          activeSearchQueryState.currentCurrency === DefaultValue ||
          activeSearchQueryState.currentCurrency === activeSearchQueryState.currentAppliedCurrency ||
          isFlexibleDateSearch ||
          isInitialLoad
        ) {
          setSearchResult({
            /**
             * set search result empty
             */
            type: SearchActions.setSearchResultData,
            payload: {
              pageInfo: {},
              total: 0,
              edges: [],
            },
          });

          // Sync with Zustand store when flag is ON
          if (shouldUseZustandForSERP) {
            const { setSearchResultData } = useSearchResultsStore.getState();
            setSearchResultData({
              pageInfo: {},
              total: 0,
              edges: [],
            });
          }

          /**
           * get search result with two api call, basic info and media
           */

          if (keywordSearch) {
            !skipQuery && getKeywordSearchDataOnAnyUIChanges();
          } else {
            !skipQuery && getSearchDataOnAnyUIChanges();
          }
        } else {
          /**
           * get currency conversion rate on currency apply filter
           */
          !skipQuery && getDataWithCurrencyFilterApplied();
          // setSearchResultAlerts(SearchPageAlerts.success);
        }
      } else {
        // used in author mode

        getSearchResultMockData();
      }
    }
    setFetchCurrencyConversionFactors(false);
    setFilterUpdateData(null);
    if (isInitialSearchCall) {
      setIsInitialSearchCall(false);
    }
  };

  useEffect(() => {
    // update search on initial load
    if (
      isSOOEnabled &&
      currentLocale === hardCodedAllLocale.en &&
      !isFlexibleDate(
        sessionData?.data
          ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
          : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
      )
    ) {
      callSegmentApi();
    } else {
      setTargetSegmentCallCompleted(true);
    }
  }, []);

  // Reset Concur application flag when user starts a new search
  useEffect(() => {
    // Reset when search is clicked
    if (isSearchClicked) {
      concurCodeAlreadyApplied.current = false;
    }
  }, [isSearchClicked]);

  useEffect(() => {
    /**
     * main function to call every UXL api
     */
    if (skipSearchTriggerFromRetryReset.current) {
      skipSearchTriggerFromRetryReset.current = false;
      return;
    }
    // Skip one api/uxl call when fallback logic forces currency back to default.
    if (skipUpdateOnCurrencyFallback.current) {
      skipUpdateOnCurrencyFallback.current = false;
      return;
    }
    // Skip duplicate call caused by isSearchClicked resetting to false after
    // updateSearchAPICalls already processed the search (Zustand batch path)
    if (skipNextSearchEffectRef.current) {
      skipNextSearchEffectRef.current = false;
      return;
    }
    if (isConcurCodeFetched) {
      if (!isInitialSearchCall) {
        // Skip if initial search was already triggered by targetSegmentCallCompleted useEffect
        if (initialSearchTriggered.current) {
          initialSearchTriggered.current = false;
          return;
        }
        // In Zustand path, isSearchClicked stays false — check the ref instead
        const isSearchClickedForSOO = shouldUseZustandForSERP ? isUpdateSearchClickedRef.current : isSearchClicked;
        if (
          isSearchClickedForSOO &&
          !targetSegmentCallCompleted &&
          isSOOEnabled &&
          currentLocale === hardCodedAllLocale.en &&
          !isFlexibleDate(
            sessionData?.data
              ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
              : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
          )
        ) {
          callSegmentApi();
        } else {
          updateSearchAPICalls();
          if (sessionObject?.accessToken && !skipQuery) {
            fetchCustomerSavedProperties();
          }
        }
      }
    }
  }, [
    activeSearchQueryState.search,
    activeSearchQueryState[SearchFacetsConstants.goToNextPage],
    JSON.stringify(activeSearchQueryState[SearchFacetsConstants.sort]),
    activeSearchQueryState.currentCurrency,
    isSearchClicked,
    isInitialSearchCall,
    isConcurCodeFetched,
  ]);
  const userDetailsState = useUserDetailsGlobalStore(state => state);

  // Calculate session token for useGetUserInfo hook
  const shouldCallGetUserInfo =
    sessionData?.authenticated &&
    featureFlags &&
    isConcurFlowActive(featureFlags, sessionData?.data || sessionData?.cacheData?.data) &&
    !userDetailsState?.isUserDetailsSaved;

  const sessionTokenForUserInfo = shouldCallGetUserInfo
    ? sessionData?.data?.sessionToken || sessionData?.cacheData?.data?.sessionToken
    : undefined;

  const { hasSettled: userInfoSettled } = useGetUserInfo({
    sessionToken: sessionTokenForUserInfo,
    requestId,
    currentLocale,
  });

  useEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;

    if (!sessionData?.authenticated) {
      setIsConcurCodeFetched(true);
      return;
    }

    if (!featureFlags) {
      return;
    }

    if (isConcurFlowActive(featureFlags, sessionData?.data || sessionData?.cacheData?.data)) {
      // Wait for user details to be loaded before proceeding
      if (userDetailsState?.isUserDetailsSaved) {
        // Only apply Concur code once per search session
        // If already applied, just mark as fetched and don't reapply
        if (concurCodeAlreadyApplied.current) {
          setIsConcurCodeFetched(true);
          return;
        }

        // Check if user has manually overridden Concur in this session
        if (hasConcurUserOverride()) {
          concurCodeAlreadyApplied.current = true;
          setIsConcurCodeFetched(true);
          return;
        }

        // Apply Concur code resolution to searchQueryState
        const concurCode = extractConcurCode(userDetailsState);
        const currentOptions = searchQueryState.search[SearchFacetsConstants.options];
        const currentRateType = currentOptions?.rateRequestTypes?.[0];

        // Extract current rate info from searchQueryState
        // rateRequestTypes mapping (from helper.tsx):
        // - { type: 'STANDARD', value: '' } → Default/Lowest Regular Rate (no user selection)
        // - { type: 'CLUSTER', value: corporateCode } → Corporate/Promo code
        // - { type: 'GOV', value: 'gov' } → Government rate
        // - { type: 'AAA', value: 'aaa' } → AAA rate
        // - { type: 'CLUSTER', value: 's9r' } → S9R rate
        // - Other CLUSTER values → Various special rates
        let currentSpecialRateCode: string | undefined = undefined;
        let currentCorpCode: string | undefined = undefined;

        if (currentRateType) {
          const rateType = (currentRateType as any)?.type;
          const rateValue = String((currentRateType as any)?.value || '');

          // Check if this is the default rate (no user selection)
          if (rateType === 'STANDARD' && rateValue === '') {
            // This is "Lowest Regular Rate" - treat as no user selection
            currentSpecialRateCode = undefined;
            currentCorpCode = undefined;
          } else if (rateType === 'CLUSTER') {
            // CLUSTER type could be: corporate code, s9r, or other special rates
            // Check if it looks like a corporate code (not a known special rate code)
            const knownSpecialRates = ['s9r', 'S9R', 'MRW', 'P17'];
            if (knownSpecialRates.includes(rateValue)) {
              // Known special rate cluster code
              currentSpecialRateCode = rateValue.toLowerCase();
            } else {
              // Treat as corporate code
              currentSpecialRateCode = 'corp';
              currentCorpCode = rateValue;
            }
          } else if (rateType === 'GOV') {
            currentSpecialRateCode = 'gov';
          } else if (rateType === 'AAA') {
            currentSpecialRateCode = 'aaa';
          } else {
            // Any other rate type is a user selection
            currentSpecialRateCode = rateValue.toLowerCase();
          }
        }

        // Apply Concur resolution
        // This uses priority logic: Use Points > User Selection > Concur Code > Default
        // If currentSpecialRateCode is set, it represents a user selection and will take priority over Concur
        const resolved = getSpecialRatesForSearch(
          currentSpecialRateCode,
          currentCorpCode,
          concurCode,
          false, // Use points not applicable here
          []
        );

        // Update searchQueryState if Concur code should be applied
        if (resolved.specialRateCode === 'corp' && resolved.corporateCode) {
          setSearchQuery({
            type: SearchActions.setQuery,
            payload: {
              [SearchFacetsConstants.options]: {
                ...currentOptions,
                rateRequestTypes: [
                  {
                    type: 'CLUSTER',
                    value: resolved.corporateCode,
                  },
                ],
              },
            },
          });
          // Mark that we've applied Concur code
          concurCodeAlreadyApplied.current = true;
        }

        // NOW it's safe to proceed with search
        setIsConcurCodeFetched(true);
      } else if (userInfoSettled) {
        // getUserInfo failed (e.g. 500) — proceed with default rates
        setIsConcurCodeFetched(true);
      }
    } else {
      setIsConcurCodeFetched(true);
    }
  }, [sessionData?.authenticated, userDetailsState?.isUserDetailsSaved, envVarsObject, userInfoSettled]);

  useEffect(() => {
    if ((targetSegmentCallCompleted && isConcurCodeFetched) || pageVal === 'chat') {
      setTargetSegmentCallCompleted(false);
      // Only set initialSearchTriggered for the actual initial search, not for
      // subsequent SOO calls from Update Search. During initial load, setIsInitialSearchCall(false)
      // inside updateSearchAPICalls triggers the UXL useEffect again — this flag prevents that
      // duplicate call. But for non-initial searches, isInitialSearchCall is already false so no
      // duplicate fires. Leaving the flag true would cause it to skip the NEXT legitimate
      // UXL trigger (e.g. filter apply).
      if (isInitialSearchCall) {
        initialSearchTriggered.current = true;
      }
      updateSearchAPICalls();
      if (sessionObject?.accessToken && !skipQuery) {
        fetchCustomerSavedProperties();
      }
    }
  }, [targetSegmentCallCompleted, AiSearchResults, isConcurCodeFetched]);

  /**
   * Function to take currency as input and generate the symbol for the same.
   * @returns fetches the saved properties of the users from uxl
   */

  const fetchCustomerSavedProperties = async () => {
    const { data } = await getCustomerToken({
      variables: {
        customerId: sessionObject?.consumerID,
      },
      context: {
        headers: {
          'x-request-id': requestId,
          Authorization: `${clientEnvVars['APOLLOGRAPHQL_AUTH_TOKEN']}, Bearer ${sessionObject?.accessToken}`,
        },
      },
    });
    const tempSavedArray: { id: any }[] = [];
    // eslint-disable-next-line array-callback-return
    data?.customer?.savedProperties?.map((item: { id: any }) => {
      tempSavedArray.push({ id: item.id });
    });
    setSavedProperties(tempSavedArray);
    dispatch({ type: 'populateState', payload: tempSavedArray });
  };

  //toggle map view
  const enableMapView = (mapViewClicked: boolean): void => {
    if (mapViewClicked) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case map button click
      setViewChangeButtonClicked(true);
    }
    // Update the view type to map in URL
    const params = new URLSearchParams(window.location.search);
    params.set(searchFilters.view, 'map');
    window.history.replaceState({}, headersData?.referer, `${decodeURIComponent(`?${params}`)}${window.location.hash}`);
    const searchFormEl = document.getElementById('document_search_form_container_el_ref');
    // setSelectedHotel([]);
    sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'true');
    document.body.style.overflow = 'hidden';

    // Check feature flag to determine if we should sync with Zustand store
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    // Check if the current view is list view before changing it to map view
    if (!isMapViewEnabled) {
      // Set transitioning state immediately to hide buttons
      setIsViewTransitioning(true);

      if (window && window.scrollY && window.scrollY !== 0) {
        // If scrolled, return to unscrolled state so vh is calculated correctly. (Safari fix.)
        window.scrollTo(0, 0);
        // Use requestAnimationFrame for better timing than setTimeout
        requestAnimationFrame(() => {
          // Update local React state (always needed for main component logic)
          setISMapViewEnabled(true);
          // Also update Zustand store if feature flag is enabled
          if (shouldUseZustand) {
            searchResultsRenderedDataStore.setISMapViewEnabled(true);
          }
          setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });
          // Clear transitioning state after view change is complete
          requestAnimationFrame(() => {
            setIsViewTransitioning(false);
          });
        });
      } else {
        // Else enable map view immediately.
        // Update local React state (always needed for main component logic)
        setISMapViewEnabled(true);
        // Also update Zustand store if feature flag is enabled
        if (shouldUseZustand) {
          searchResultsRenderedDataStore.setISMapViewEnabled(true);
        }
        setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });
        // Clear transitioning state after next frame to ensure render completes
        requestAnimationFrame(() => {
          setIsViewTransitioning(false);
        });
      }
    }
    if (searchFormEl) {
      searchFormEl?.classList.add('map-view-sticky');
      // searchFormEl.style.top = `0px`; // AFAIK this isn't necessary. Leaving in case a regression shows up in testing.
      searchFormEl?.focus();
    }
    if (mapViewClicked) {
      if (sessionStorage.getItem('updateSearchCounter')) {
        const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
      } else {
        sessionStorage.setItem('updateSearchCounter', '0');
      }
      const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
      setUpdateSearchCounter(parseInt(searchCounterValue || '0', 10));
      // Update the window.location.hash with the update search counter
      window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
      // Note: dataLayer update moved to useEffect for React Compiler compatibility
    }
  };

  //toggle list view
  const enableListView = (listViewClicked: boolean): void => {
    if (listViewClicked) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case list button click
      setViewChangeButtonClicked(true);
    }
    // Update the view type to list in URL
    const params = new URLSearchParams(window.location.search);
    params.set(searchFilters.view, 'list');
    window.history.replaceState({}, headersData?.referer, `${decodeURIComponent(`?${params}`)}${window.location.hash}`);

    // Check feature flag to determine if we should sync with Zustand store
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    // Check if the current view is map view before changing it to list view
    if (isMapViewEnabled) {
      // Set transitioning state immediately to prevent button flicker
      setIsViewTransitioning(true);

      // Update local React state (always needed for main component logic)
      setISMapViewEnabled(false);
      // Also update Zustand store if feature flag is enabled
      if (shouldUseZustand) {
        searchResultsRenderedDataStore.setISMapViewEnabled(false);
      }
      setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });

      // Clear transitioning state after next frame to ensure render completes
      requestAnimationFrame(() => {
        setIsViewTransitioning(false);
      });
    }
    document.body.style.overflow = 'auto';
    sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'false');
    // Note: DOM manipulations moved to useEffect for React Compiler compatibility
    // eventUtil.dispatch('makeSearchFormStickyForMapView', {isMapViewEnabled:false});
    if (listViewClicked) {
      if (sessionStorage.getItem('updateSearchCounter')) {
        const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
      } else {
        sessionStorage.setItem('updateSearchCounter', '0');
      }
      const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
      setUpdateSearchCounter(parseInt(searchCounterValue || '0', 10));
      // Update the window.location.hash with the update search counter
      // window.location.hash = `#/${searchCounterValue}/`;
      window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
      // Note: dataLayer update moved to useEffect for React Compiler compatibility
    }
  };

  useEffect(() => {
    /**
     * Show map or list view on the basis of session/URL params.
     * For initial load when view=map, keep the view as list until search results are fetched.
     * Skip this for chat context - map view is already initialized and we don't want side effects.
     */
    if (pageVal === 'chat') {
      // For chat, map view is already set via initial state (isMapViewEnabled = true)
      // Just ensure property list is shown when results are loaded (no URL/session side effects)
      if (!isLoadingSearchResult) {
        setHidePropertyList(false);
      }
      return;
    }

    if (isLoadingSearchResult) {
      // While search results are loading, do not switch to map view even if session or URL says view=map.
      // We rely on the default list view state during this time.
      return;
    }

    const resultsViewType = completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
      ? completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
      : completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.searchResultViewType;
    const searchMapValue = sessionStorage?.getItem(MAP_VIEW_SESSION_KEY);

    // Prefer explicit URL param (view=map|list) over session values on initial load.
    const params = new URLSearchParams(window.location.search);
    const urlViewParam = params.get(searchFilters.view);
    let shouldShowMap: boolean | null = null;

    if (urlViewParam === 'map') {
      shouldShowMap = true;
    } else if (urlViewParam === 'list') {
      shouldShowMap = false;
    }

    if (shouldShowMap === null) {
      shouldShowMap = resultsViewType === 'map' || searchMapValue === 'true';
    }

    if (shouldShowMap && !errorScenario) {
      enableMapView(false);
      if (suppressListUntilMapReady) {
        setHidePropertyList(false);
        setSuppressListUntilMapReady(false);
      }
    } else {
      enableListView(false);
      if (suppressListUntilMapReady) {
        // We expected to prefer map view but could not (e.g. error scenario).
        // At this point, allow the list view to render.
        setHidePropertyList(false);
        setSuppressListUntilMapReady(false);
      }
    }

    const dataLayerObj = window.dataLayer ?? {};
    updateDataLayerObjSigin(dataLayerObj, datalayerProperties);
    if (window && window?.dataLayer) {
      window.dataLayer['search_list_setting_sort_order'] =
        (searchResult?.searchCenter?.latitude === null || searchResult?.searchCenter === null) &&
        (!activeSearchQueryState?.search?.latitude || activeSearchQueryState?.search?.latitude === null) &&
        activeSearchQueryState[SearchFacetsConstants.sort]?.fields[1]?.field === 'CITY'
          ? activeSearchQueryState[SearchFacetsConstants.sort]?.fields[1].field?.toLowerCase()
          : activeSearchQueryState[SearchFacetsConstants.sort]?.fields[0].field?.toLowerCase();
    }
  }, [isLoadingSearchResult]);

  useEffect(() => {
    /**
     * Handler for resize event
     */
    if (window && window?.screen?.width && window?.dataLayer) {
      const screenSize = window?.screen?.width;
      if (screenSize < 992) {
        window.dataLayer['is_desktop'] = false;
      } else {
        window.dataLayer['is_desktop'] = true;
      }
    }
    const resizeHandler = (): void => {
      const currentViewIsMobile = CommonUtils.isOnlyMobileView();
      if (!isMobileState) {
        // viewport was not mobile earlier but now its mobile
        if (currentViewIsMobile) {
          setIsMobile(true);
        }
      } else {
        // viewport was mobile earlier but now its not
        if (!currentViewIsMobile) {
          setIsMobile(false);
        }
      }
    };
    window.addEventListener('resize', resizeHandler, { passive: true });
    return (): void => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [isMobileState]);

  const FilterProvideValue = useMemo(() => {
    /**
     * use memo hook to avoid assignment on every render
     * When Zustand flag is enabled, use Zustand store's searchQueryState
     * Otherwise, use Context reducer's searchQueryState
     */
    return {
      searchQueryState: activeSearchQueryState,
      setSearchQuery,
    };
  }, [activeSearchQueryState, setSearchQuery]);
  const SearchResultProviderValue = useMemo(() => {
    return { searchResult, setSearchResult };
  }, [searchResult, setSearchResult]);
  const SearchResultErrorProviderValue = useMemo(() => {
    return { searchResultAlerts, setSearchResultAlerts };
  }, [searchResultAlerts, setSearchResultAlerts]);

  // TODO: validate this need to wrap inside a function
  // Skip this for chat context to allow map view by default
  if (isMapViewEnabled && !searchResultAlerts.showPageAndFilter && pageVal !== 'chat') {
    enableListView(false);
  }

  const setDefaultCurrency = (): void => {
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentCurrency: DefaultValue,
        currentAppliedCurrency: DefaultValue,
      },
    });
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
    // Update the currency filter to default in the URL
    updateQueryParams(
      {
        selectedCurrency: DefaultValue,
      },
      ['selectedCurrency'],
      headersData?.referer
    );
  };

  const resetAllFilter = (): void => {
    const payload = getSearchFilterClearState();
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...activeSearchQueryState.search[SearchFacetsConstants.facets],
          ...getSearchAppliedFilter(payload, activeSearchQueryState),
        },
      },
    });
    if (wasMapViewEnabled) {
      // Check feature flag to determine if we should sync with Zustand store
      const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
      const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

      // Update local React state (always needed for main component logic)
      setISMapViewEnabled(true);
      // Also update Zustand store if feature flag is enabled
      if (shouldUseZustand) {
        searchResultsRenderedDataStore.setISMapViewEnabled(true);
      }
      document.body.style.overflow = 'hidden';
      sessionStorage.setItem(MAP_VIEW_SESSION_KEY, 'true');
      setWasMapViewEnabled(false);
    }
  };

  // Tooltip handling: CheckboxControlsList keeps assigning the hovered element to this ref.
  const tooltipAnchorRef = useRef<HTMLSpanElement | null>(null);
  // Store the latest payload + visibility flag; avoids rerendering lists on hover churn.
  const tooltipPendingContentRef = useRef<TooltipContentProps>({});
  const tooltipLayerRef = useRef<TooltipLayerHandle>(null);
  const tooltipVisibilityRef = useRef(false);

  // Checkbox controls push payloads here; the portal reads from the ref as soon as showToolTip flips true.
  const handleSetTooltipContent = useCallback((content: TooltipContentProps) => {
    tooltipPendingContentRef.current = content ?? {};
  }, []);

  const handleSetShowToolTip = useCallback(
    (value: React.SetStateAction<boolean>) => {
      const nextValue = typeof value === 'function' ? value(tooltipVisibilityRef.current) : value;
      tooltipVisibilityRef.current = nextValue;
      if (nextValue) {
        // When the checkbox toggles the tooltip on, the anchor ref might not be populated yet.
        // Retry with requestAnimationFrame so we always measure after the checkbox finishes its own updates.
        const content = tooltipPendingContentRef.current;
        const tooltipKey =
          content?.tooltipCode && tooltipAmenities[content.tooltipCode as keyof typeof tooltipAmenities]
            ? (tooltipAmenities[content.tooltipCode as keyof typeof tooltipAmenities] as string)
            : '';
        const tooltipText = content?.tooltipText ?? (tooltipKey ? jsonContent?.[tooltipKey] ?? '' : '');

        const tryShow = (attempt = 0) => {
          const anchor = tooltipAnchorRef.current;
          if (!anchor) {
            if (attempt < 4) {
              requestAnimationFrame(() => tryShow(attempt + 1));
            }
            return;
          }
          tooltipLayerRef.current?.showTooltip({
            heading: content?.tooltipHeading ?? '',
            text: tooltipText,
            anchor,
          });
        };

        tryShow();
      } else {
        tooltipLayerRef.current?.hideTooltip();
        tooltipAnchorRef.current = null;
      }
    },
    [jsonContent]
  );

  const showBannerConditionsInListView = (): boolean => {
    const result = !featureSelected && nightsCount >= 4 && pointsChecked && !isMapViewEnabled;
    return result;
  };

  const showMemberExclusiveBannerInListView = useMemo(
    () => showBannerConditionsInListView(),
    [featureSelected, nightsCount, pointsChecked, isMapViewEnabled]
  );

  const showBannerConditionsInMapView = (): boolean => {
    const result = !featureSelected && nightsCount >= 4 && pointsChecked && isMapViewEnabled;
    return result;
  };

  const showMemberExclusiveBannerInMapView = useMemo(
    () => showBannerConditionsInMapView(),
    [featureSelected, nightsCount, pointsChecked, isMapViewEnabled]
  );

  const isBackendUpdating = useRef<boolean>(false);
  const queue = useRef<any>([]);

  const consumeRevisionToken = () => {
    if (sessionData) {
      setRevisionToken(
        sessionData?.data
          ? sessionData?.data?.AriesCommon?.revisionToken
          : sessionData?.cacheData?.data?.AriesCommon?.revisionToken
      );
      custNumber.current = sessionData?.data ? sessionData?.data?.consumerID : sessionData?.cacheData?.data?.consumerID;
    }
  };

  const initialData = {
    // revisionToken: revisionToken,
    savedPropertiesList: savedProperties,
    triggerSaveProperties: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const savedPropertiesReducer = (dataList: typeof initialData, action: any) => {
    switch (action.type) {
      case 'added': {
        dataList.savedPropertiesList.push({ id: action.payload });
        return { ...dataList, triggerSaveProperties: true };
      }
      case 'removed': {
        dataList.savedPropertiesList = dataList.savedPropertiesList.filter((data: any) => data.id !== action.payload);
        return { ...dataList, triggerSaveProperties: true };
      }
      case 'populateState': {
        dataList.savedPropertiesList = action.payload;
        return { ...dataList, triggerSaveProperties: false };
      }
      case 'populateStateWithCallback': {
        dataList.savedPropertiesList = action.payload;
        return { ...dataList, triggerSaveProperties: true };
      }
      default: {
        return dataList;
      }
    }
  };

  const [savedData, dispatch] = useReducer(savedPropertiesReducer, initialData);

  // Initialize SearchFilter Zustand store when flag is enabled (independent pattern)
  // This syncs the reducer's INITIAL state into the Zustand store ONCE
  useEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    if (shouldUseZustand) {
      // Initialize SearchFilter store ONCE with the initial search query data from reducer
      // After this, the Zustand store becomes the source of truth (when flag is ON)
      // Updates happen via the setSearchQuery wrapper which calls direct store methods
      searchFilterStore.searchFilterInitialization(searchQueryState);
    }
  }, [shouldUseZustandForSERP]); // Only initialize once when flag becomes true

  // Initialize SavedPropertiesDispatch Zustand store when flag is enabled (independent pattern)
  useEffect(() => {
    const featureFlags = envVarsObject?.['featureFlags'] as unknown as Record<string, any> | undefined;
    const shouldUseZustand = featureFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_SHOP_SERP_ZUSTAND] ?? false;

    if (shouldUseZustand && savedData) {
      // Initialize SavedProperties store with current saved data
      savedPropertiesDispatchStore.savedPropertiesInitialization(savedData.savedPropertiesList);
    }
  }, [savedData, envVarsObject]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const consumeSavedProperties = async (data: any) => {
    const savedPropertyData = data;
    if (savedPropertyData) {
      if (savedPropertyData?.updateCustomerSavedProperties?.status[0]?.httpStatus === 200) {
        setRevisionToken(savedPropertyData?.updateCustomerSavedProperties?.revisionToken);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const savedPropertiesArrayWithId: any = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        savedPropertyData?.updateCustomerSavedProperties?.savedProperties?.map((idValue: any) =>
          savedPropertiesArrayWithId.push({ id: idValue.id })
        );
        setSavedProperties(savedPropertiesArrayWithId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const marshaList: any = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        savedPropertiesArrayWithId?.map((marsha: any) => marshaList.push(marsha?.id.toLowerCase()));

        isBackendUpdating.current = false;
        if (queue.current.length !== 0) {
          dispatch({ type: 'populateStateWithCallback', payload: savedPropertiesArrayWithId });
          if (shouldUseZustandForSERP) {
            savedPropertiesDispatchStore.dispatch({
              type: 'populateStateWithCallback',
              payload: savedPropertiesArrayWithId,
            });
          }
        } else {
          dispatch({ type: 'populateState', payload: savedPropertiesArrayWithId });
          if (shouldUseZustandForSERP) {
            savedPropertiesDispatchStore.dispatch({ type: 'populateState', payload: savedPropertiesArrayWithId });
          }
        }
      }
    } else if (isSavedDataStaleError) {
      setIsSavedDataStaleError(true);
    }
  };

  const checkStaleError = (data: DataUpdateProperties) => {
    if (data?.updateCustomerSavedProperties?.status[0]?.httpStatus === 412) {
      setIsSavedDataStaleError(true);
    }
  };

  //formation of update properties query
  const [updateProperties] = useMutation(phoenixShopUpdateCustomerSavedProperties, {
    onCompleted: data => {
      consumeSavedProperties(data);
      checkStaleError(data);
    },
    // notifyOnNetworkStatusChange: true, // did the work
    onError: error => {
      if (pageVal !== 'chat') {
        Axios.post(loggerApiURL, {
          message: `update property error for sessionId ${sessionID}: ${JSON.stringify(error)}`,
        });
      }
    },
  });

  useEffect(() => {
    if (sessionObject?.consumerID && sessionObject?.accessToken && savedData.triggerSaveProperties) {
      //removing dulicate values from array which was causing the UXL call to break
      const uniqueSavedProperties = savedData?.savedPropertiesList?.filter((obj: { id: any }, index: number) => {
        return index === savedData?.savedPropertiesList?.findIndex((o: { id: any }) => obj.id === o.id);
      });
      if (!isBackendUpdating.current) {
        isBackendUpdating.current = true;

        const params = {
          input: {
            id: sessionObject?.consumerID,
            revisionToken: revisionToken,
            savedProperties: queue.current.length === 0 ? uniqueSavedProperties : queue.current.shift(),
          },
        };

        updateProperties({
          variables: {
            ...params,
          },
          context: {
            headers: {
              'x-request-id': requestId,
            },
          },
        });
      } else {
        queue.current.push(uniqueSavedProperties);
      }
    }
  }, [savedData]);

  // When Zustand flag is ON, child components dispatch to the Zustand store (not the local reducer).
  // Subscribe to Zustand savedData changes to trigger the updateProperties mutation.
  const zustandSavedData = savedPropertiesDispatchStore.savedData;
  useEffect(() => {
    if (!shouldUseZustandForSERP) {
      return;
    }
    if (sessionObject?.consumerID && sessionObject?.accessToken && zustandSavedData.triggerSaveProperties) {
      const uniqueSavedProperties = zustandSavedData?.savedPropertiesList?.filter((obj: { id: any }, index: number) => {
        return index === zustandSavedData?.savedPropertiesList?.findIndex((o: { id: any }) => obj.id === o.id);
      });
      if (!isBackendUpdating.current) {
        isBackendUpdating.current = true;

        const params = {
          input: {
            id: sessionObject?.consumerID,
            revisionToken: revisionToken,
            savedProperties: queue.current.length === 0 ? uniqueSavedProperties : queue.current.shift(),
          },
        };

        updateProperties({
          variables: {
            ...params,
          },
          context: {
            headers: {
              'x-request-id': requestId,
            },
          },
        });
      } else {
        queue.current.push(uniqueSavedProperties);
      }
    }
  }, [zustandSavedData]);

  // Initialize Zustand store for SearchResultContext when flag is ON
  useEffect(() => {
    if (shouldUseZustandForSERP) {
      const { searchResultInitialization } = useSearchResultsStore.getState();
      searchResultInitialization({
        total: searchResult.total,
        pageInfo: searchResult.pageInfo,
        edges: searchResult.edges,
        searchCenter: searchResult.searchCenter,
        showMapView: searchResult.showMapView,
        media: searchResult.media,
        facets: searchResult.facets,
        currentOffset: searchResult.currentOffset,
        geoCodeInfo: searchResult.geoCodeInfo,
        llmMetadata: searchResult.llmMetadata,
        messageUiData: searchResult.messageUiData,
      });
    }
  }, [searchResult, shouldUseZustandForSERP]);

  useEffect(() => {
    eventUtil.on('changeZIndex', value => {
      if (document) {
        const filterEle = document.getElementsByClassName(
          'filters-container filters-map-view-container'
        ) as HTMLCollectionOf<HTMLElement>;
        const buttonEle = document.getElementsByClassName('drawer-icon-container') as HTMLCollectionOf<HTMLElement>;
        if (value && filterEle && buttonEle && filterEle.length) {
          filterEle[0]?.style.setProperty('z-index', '1');
          buttonEle[0]?.style.setProperty('z-index', '0', 'important');
        } else {
          filterEle[0]?.style.setProperty('z-index', '2');
          buttonEle[0]?.style.setProperty('z-index', '1');
        }
      }
    });
    return (): void => {
      eventUtil.remove('changeZIndex', () => {});
    };
  }, []);

  return (
    <renderedData.Provider value={renderedDataValue}>
      <SearchResultContext.Provider value={SearchResultProviderValue}>
        <SearchResultAlertContext.Provider value={SearchResultErrorProviderValue}>
          <SavedPropertiesDispatchContext.Provider value={{ savedData, dispatch }}>
            {/* show loader on click update search and return response upon successful UXL call */}
            {searchResultAlerts?.showPageAndFilter || isLoadingSearchResult || isStaticMap ? (
              <SearchFilterContext.Provider value={FilterProvideValue}>
                <StyledSearchResultContainerDiv
                  className={clsx(
                    pageVal === 'chat' && !isMapViewEnabled && !isStaticMap ? 'p-3' : ' ',
                    pageVal !== 'chat' ? 'm-container-fullbleed ' : ' ',
                    isMapViewEnabled || isStaticMap ? 'map-view ' : 'list-view alternate ',
                    !searchResultAlerts.showPageAndFilter ||
                      !searchResult.total ||
                      propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '')
                      ? 'no-map-button'
                      : '',
                    isViewTransitioning ? 'view-transitioning' : '',
                    segmentId ? segmentId : DEFAULT_SORT_OPTS
                  )}
                >
                  {/* Dedicated portal for tooltips so list items no longer need to render inline popovers. */}
                  <SearchResultsTooltipLayer ref={tooltipLayerRef} />
                  <>
                    {/* Hide filters and other UI when in static map mode */}
                    {!isStaticMap && (
                      <StyledFilterContainerDiv
                        className={clsx(
                          isMapViewEnabled ? 'filters-container filters-map-view-container' : 'filters-container',
                          pageVal === 'chat' ? 'chat-filters-map-view-container' : ''
                        )}
                      >
                        <FiltersComponent
                          filterUpdateData={filterUpdateData}
                          isStateOrCountrySearch={isStateOrCountrySearch}
                          isDestinationSearch={isDestinationSearch}
                          className="filter-component"
                          setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                          tooltipRefElement={tooltipAnchorRef}
                          setTooltipContent={handleSetTooltipContent}
                          modalRefElement={modalRefElement}
                          setShowToolTip={handleSetShowToolTip}
                          enableMapView={enableMapView}
                          enableListView={enableListView}
                        />
                        {showMemberExclusiveBannerInListView && (
                          <MemberExclusiveBanner numberOfNights={nightsCount} pointsChecked={pointsChecked} />
                        )}
                        {showMemberExclusiveBannerInMapView && !isLargeDesktop && (
                          <MemberExclusiveBanner numberOfNights={nightsCount} pointsChecked={pointsChecked} />
                        )}
                        {!isMapViewEnabled && !errorScenario && (
                          <PaginationSortByComponent
                            isMobileState={isMobileState}
                            className={`pagination-sort-container search-results pb-md-2 ${
                              pageVal === 'chat' ? ' p-md-3' : ''
                            }`}
                            segmentId={segmentId}
                            isLatLongAvailable={isStateOrCountrySearch}
                            setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                            isCorpCodeEntered={isCorpCodeEntered}
                            destinationType={updatedDestinationType}
                          />
                        )}

                        {!isMapViewEnabled &&
                        searchResultAlerts?.errorMessage &&
                        searchResultAlerts?.showPageAndFilter &&
                        !isUnsuccessfulUserJourney() &&
                        (!hasRetried || (hasRetried && retryFailedWithWarn1000)) &&
                        searchResultAlerts?.type !== 'unsuccessfulSell' ? (
                          <AlertNotification
                            setLinkClick={
                              activeSearchQueryState.currentCurrency === DefaultValue
                                ? resetAllFilter
                                : setDefaultCurrency
                            }
                            clickTrackingText={`Phoenix Search Results | ${
                              searchResultAlerts?.type === 'no-hotels'
                                ? 'Hotel Directory'
                                : 'Alert: Set default currency link clicked'
                            } | internal`}
                          />
                        ) : (
                          ''
                        )}
                        {!isMapViewEnabled &&
                        searchResultAlerts?.showPageAndFilter &&
                        !isUnsuccessfulUserJourney() &&
                        hasRetried &&
                        !retryFailedWithWarn1000 &&
                        warnRates1000RelatedWarningBlock?.message &&
                        searchResultAlerts?.type !== 'unsuccessfulSell' ? (
                          <Messages
                            className="unsuccess-full-journey"
                            messageType="warning"
                            messageVariation={false}
                            messageText={warnRates1000RelatedWarningBlock?.message}
                            messageContentTabIndex={0}
                            messageRole="alert"
                          />
                        ) : (
                          ''
                        )}
                        {!isMapViewEnabled &&
                        searchResultAlerts?.errorMessage &&
                        searchResultAlerts?.showPageAndFilter &&
                        isUnsuccessfulUserJourney() &&
                        searchResultAlerts?.type === 'unsuccessfulSell' ? (
                          <Messages
                            className="unsuccess-full-journey"
                            messageType="warning"
                            messageVariation={false}
                            messageHeading={searchResultAlerts?.heading}
                            messageText={searchResultAlerts?.errorMessage}
                            messageContentTabIndex={0}
                            messageRole="alert"
                          />
                        ) : (
                          ''
                        )}
                      </StyledFilterContainerDiv>
                    )}
                    {hidePropertyList && pageVal !== 'chat' ? (
                      <SkeletonPropertyCardLoaderComponent
                        isViewportL={isDesktop}
                        isInitialLoad={isInitialLoad}
                        isMapViewEnabled={isMapViewEnabled}
                        segmentId={segmentId}
                        isLatLongAvailable={isStateOrCountrySearch}
                      />
                    ) : (
                      <>
                        <div className="search-form-container">
                          <StyledSearchResultPropertyContainer
                            className={
                              (isMapViewEnabled && pageVal !== 'chat') || isStaticMap
                                ? clsx(
                                    'search-results-container',
                                    'color-scheme1',
                                    'search-map-view-result-container',
                                    isDrawerVisible ? 'active-drawer' : '',
                                    popPupOpen ? 'map-popup-position' : ''
                                  )
                                : clsx('search-results-container', isLoadingSearchResult ? 'hide-property-list' : '')
                            }
                          >
                            <PropertyListComponent
                              isMobileState={isMobileState}
                              memberExclusiveBannerDetails={{
                                featureSelected: featureSelected,
                                numberOfNights: nightsCount,
                                pointsChecked: pointsChecked,
                              }}
                              alertLinkClickFn={
                                activeSearchQueryState.currentCurrency === DefaultValue
                                  ? resetAllFilter
                                  : setDefaultCurrency
                              }
                              handleStaleError={isSavedDataStaleError}
                              handlePopUpOpen={setPopupOpen}
                              enableListView={enableListView}
                              handleNextClick={handleNextClick}
                              isDrawerVisible={isDrawerVisible}
                              segmentId={segmentId}
                              isLatLongAvailable={isStateOrCountrySearch}
                              setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                              isCorpCodeEntered={isCorpCodeEntered}
                              onOpenHotelPanel={onOpenHotelPanel}
                              hasRetried={hasRetried}
                              retryFailedWithWarn1000={retryFailedWithWarn1000}
                              warnRates1000RelatedWarningBlock={warnRates1000RelatedWarningBlock}
                            />
                          </StyledSearchResultPropertyContainer>
                          {isLoadingSearchResult && pageVal !== 'chat' && (
                            <SkeletonPropertyCardLoaderComponent
                              isViewportL={isDesktop}
                              isInitialLoad={isInitialLoad}
                              isMapViewEnabled={isMapViewEnabled}
                              segmentId={segmentId}
                              isLatLongAvailable={isStateOrCountrySearch}
                            />
                          )}
                          {isMapViewEnabled && pageVal !== 'chat' && (
                            <button
                              type="button"
                              className={`drawer-icon-container color-scheme1 analytics-click custom_click_track ${
                                isDrawerVisible && 'active-drawer hide-drawer'
                              }`}
                              aria-label={jsonContent.propertyCardDrawerLabel}
                              onClick={(): void => setIsDrawerVisible(!isDrawerVisible)}
                              {...{
                                custom_click_track_value: `${clickTrackingLoc}| Property Card Drawer ${
                                  isDrawerVisible ? 'Opened' : 'Closed'
                                } |internal`,
                              }}
                              tabIndex={0}
                            >
                              <div className={`icon-arrow-${isDrawerVisible ? 'left' : 'right'} first`} />
                              <div className={`icon-arrow-${isDrawerVisible ? 'left' : 'right'} second`} />
                            </button>
                          )}
                        </div>
                        {((!isDesktop && !isLargeDesktop) || pageVal === 'chat') &&
                          !isMapViewEnabled &&
                          !isStaticMap &&
                          !isViewTransitioning && (
                            <div
                              className={clsx(
                                pageVal === 'chat'
                                  ? 'map-button-container-chat container fixed-button'
                                  : 'map-button-container container fixed-button'
                              )}
                            >
                              {pageVal === 'chat' ? (
                                <button
                                  className="map-button m-button-primary-inverse custom_click_track"
                                  // custom_click_track_value={`${clickTrackingLoc}|  back to map view from list view |internal`}
                                  {...{ custom_click_track_value: `QuickFilters| map | internal` }}
                                  onClick={() => enableMapView(true)}
                                >
                                  <span className="icon icon-map"></span> {jsonContent?.mapLabel}
                                </button>
                              ) : (
                                <button
                                  className="map-button m-button-primary-inverse custom_click_track"
                                  // custom_click_track_value={`${clickTrackingLoc}|  back to map view from list view |internal`}
                                  {...{ custom_click_track_value: `QuickFilters| map | internal` }}
                                  onClick={() => enableMapView(true)}
                                >
                                  <span className="icon icon-map"></span> {jsonContent?.mapLabel}
                                </button>
                              )}
                            </div>
                          )}
                      </>
                    )}
                  </>
                </StyledSearchResultContainerDiv>
              </SearchFilterContext.Provider>
            ) : (
              <StyledAlertNotificationDiv>
                <AlertNotification isNonPropertyList={true} isAloneOnPage={true} />
              </StyledAlertNotificationDiv>
            )}
          </SavedPropertiesDispatchContext.Provider>
        </SearchResultAlertContext.Provider>
      </SearchResultContext.Provider>
    </renderedData.Provider>
  );
};

export default SearchResultComp;
